/* eslint-disable no-mixed-spaces-and-tabs */
import { MaterialTableColumnProps } from '../components/material-table/material-table';
import { getApiConfigSafe } from '../utils/api-config';

export const journalEntryColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.journal_entry.table.posting_date_label",
    accessorKey: "posting_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.journal_entry.table.series_number_label",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.journal_entry.table.status_label",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.journal_entry.table.amount_label",
    accessorKey: "total_amount",
    visible: true,
    type: "amount",
    enableSorting: true
  },
  {
    header: "accounting.journal_entry.table.created_by_label",
    accessorKey: "created_by_data.name",
    visible: true,
    type: "string",
  },
];
export const userColumns = [
  {
    header: "user.user.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "user.user.table.first_name_header",
    accessorKey: "first_name",
    visible: true,
    type: "string",
  },
  {
    header: "user.user.table.last_name_header",
    accessorKey: "last_name",
    visible: true,
    type: "string",
  },
  {
    header: "user.user.table.email_header",
    accessorKey: "email",
    visible: true,
    type: "string",
  },
  {
    header: "user.user.table.phone_header",
    accessorKey: "phone",
    visible: true,
    type: "string",
  },
];
export const languageColumns = [
  {
    header: "user.language.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "user.language.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "user.language.table.code_header",
    accessorKey: "code",
    visible: true,
    type: "string",
  },
  {
    header: "user.language.table.iso_code_header",
    accessorKey: "iso_code",
    visible: true,
    type: "string",
  },
  {
    header: "user.language.table.direction_header",
    accessorKey: "direction",
    visible: true,
    type: "string",
  },
  {
    header: "user.language.table.is_active_header",
    accessorKey: "is_active",
    visible: true,
    type: "custom",
  },
];
export const paymentColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.payment.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.payment.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.payment.table.journal_header",
    accessorKey: "journal_type_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.payment.table.type_header",
    accessorKey: "type",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.payment.table.vendor_header",
    accessorKey: "entry_data.name",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "accounting.payment.table.total_amount_header",
    accessorKey: "total_amount",
    visible: true,
    type: "currency",
    enableSorting: false
  },
  {
    header: "accounting.payment.table.approval_status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.payment.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.payment.table.party_type_header",
    accessorKey: "party_type",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.payment.table.is_advance_header",
    accessorKey: "is_advance",
    visible: false,
    type: "boolean",
  },
  {
    header: "accounting.payment.table.bank_account_header",
    accessorKey: "bank_account_data.bank_name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.payment.table.account_header",
    accessorKey: "accounts_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.payment.table.currency_header",
    accessorKey: "currency_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.payment.table.exchange_rate_header",
    accessorKey: "exchange_rate",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.payment.table.company_header",
    accessorKey: "company_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.payment.table.reference_number_header",
    accessorKey: "reference_number",
    visible: false,
    type: "string",
  },
];

export const collectionColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.collection.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.collection.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.collection.table.journal_header",
    accessorKey: "journal_type_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.collection.table.type_header",
    accessorKey: "type",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.collection.table.customer_header",
    accessorKey: "entry_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.collection.table.total_amount_header",
    accessorKey: "total_amount",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.collection.table.approval_status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.collection.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.collection.table.party_type_header",
    accessorKey: "party_type",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.collection.table.is_advance_header",
    accessorKey: "is_advance",
    visible: false,
    type: "boolean",
  },
  {
    header: "accounting.collection.table.bank_account_header",
    accessorKey: "bank_account_data.bank_name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.collection.table.account_header",
    accessorKey: "accounts_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.collection.table.currency_header",
    accessorKey: "currency_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.collection.table.exchange_rate_header",
    accessorKey: "exchange_rate",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.collection.table.company_header",
    accessorKey: "company_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.collection.table.reference_number_header",
    accessorKey: "reference_number",
    visible: false,
    type: "string",
  },
];

export const paymentRequestColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.request.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
  },
  {
    header: "accounting.request.table.customer_header",
    accessorKey: "customer_data.name",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "accounting.request.table.payment_status_header",
    accessorKey: "payment_status",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.request.table.status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.invoice.table.total_invoice_value_header",
    accessorKey: "total_invoice_amount",
    visible: true,
    type: "amount",
    showDefaultCurrency: true
  },
  {
    header: "accounting.invoice.table.party_amount_header",
    accessorKey: "party_amount",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.request.table.due_date_header",
    accessorKey: "due_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.request.table.currency_header",
    accessorKey: "currency_data.currency_name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.request.table.company_header",
    accessorKey: "company_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.request.table.exchange_rate_header",
    accessorKey: "exchange_rate",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.request.table.incoterm_header",
    accessorKey: "incoterm_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.request.table.additional_discount_on_header",
    accessorKey: "additional_discount_on",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.request.table.additional_discount_percentage_header",
    accessorKey: "additional_discount_percentage",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.request.table.additional_discount_amount_header",
    accessorKey: "additional_discount_amount",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.request.table.round_off_header",
    accessorKey: "round_off",
    visible: false,
    type: "boolean",
  },
];

export const customerManagementColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.customer_management.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.customer_management.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.customer_management.table.phone_number_header",
    accessorKey: "contact_no",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.customer_management.table.emails_header",
    accessorKey: "email_ids",
    visible: true,
    type: "jsonArray",
  },
  {
    header: "accounting.customer_management.table.salesperson_header",
    accessorKey: "salesperson_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.customer_management.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.customer_management.table.payment_term_header",
    accessorKey: "payment_term_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.customer_management.table.credit_limit_header",
    accessorKey: "credit_limit",
    visible: true,
    type: "string",
  },
];

export const vendorManagementColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.vendor_management.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.vendor_management.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.vendor_management.table.phone_number_header",
    accessorKey: "contact_no",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.vendor_management.table.emails_header",
    accessorKey: "email_ids",
    visible: true,
    type: "jsonArray",
  },
  {
    header: "accounting.vendor_management.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.vendor_management.table.payment_term_header",
    accessorKey: "payment_term_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.vendor_management.table.credit_limit_header",
    accessorKey: "credit_limit",
    visible: true,
    type: "string",
  },
];

export const budgetColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.budget.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
    size: 80,
  },
  {
    header: "accounting.budget.table.budget_name_header",
    accessorKey: "budget_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.budget.table.budget_type_header",
    accessorKey: "budget_type_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.budget.table.financial_year_header",
    accessorKey: "financial_year_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.budget.table.total_amount_header",
    accessorKey: "total_amount",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.budget.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];

export const assetTransferColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.asset_transfer.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
  },
  {
    header: "accounting.asset_transfer.table.transfer_name_header",
    accessorKey: "transfer_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.asset_transfer.table.asset_name_header",
    accessorKey: "asset_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.asset_transfer.table.destination_location_header",
    accessorKey: "destination_location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.asset_transfer.table.approval_status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "status",
  },
];

export const assetManagementColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.asset_management.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
  },
  {
    header: "accounting.asset_management.table.asset_type_header",
    accessorKey: "asset_type_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.asset_management.table.asset_name_header",
    accessorKey: "asset_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.asset_management.table.asset_value_header",
    accessorKey: "asset_value",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.asset_management.table.depreciable_value_header",
    accessorKey: "depreciation_data.depreciated_value",
    visible: true,
    type: "amount",
    enableSorting: false
  },
  {
    header: "accounting.asset_management.table.net_asset_value_header",
    accessorKey: "net_asset_value",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.asset_management.table.depreciation_method_header",
    accessorKey: "depreciation",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.asset_management.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const commissionPlanColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.commission_plan.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission_plan.table.title_header",
    accessorKey: "title",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission_plan.table.type_header",
    accessorKey: "type",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission_plan.table.company_header",
    accessorKey: "company_data",
    visible: true,
    type: "array",
    typeArrayAccessorKey: "name",
  },
  {
    header: "accounting.commission_plan.table.apply_on_header",
    accessorKey: "applied_on",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission_plan.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "boolean",
    typeBooleanLabels: {
      0: "Inactive",
      1: "Active",
      false: "Inactive",
      true: "Active",
    },
  },
];

export function getCommissionTargetColumns(): MaterialTableColumnProps[] {
  const config = getApiConfigSafe();
  const isDevSpar = config?.appEnv === 'dev_spar';
  return [
    {
      header: "accounting.commission_target.table.id_header",
      accessorKey: "series_number",
      visible: true,
      type: "string",
    },
    {
      header: "accounting.commission_target.table.salesperson_header",
      accessorKey: "salesperson_data.name",
      visible: true,
      type: "string",
    },
    ...(isDevSpar?[{
      header: "accounting.commission_target.table.type_header",
      accessorKey: "type",
      visible: true,
      type: "string",
    }]:[]),
    {
      header: "accounting.commission_target.table.start_date_header",
      accessorKey: "start_date",
      visible: true,
      type: "date",
    },
    ...(!isDevSpar ? [{
      header: "accounting.commission_target.table.end_date_header",
      accessorKey: "end_date",
      visible: true,
      type: "date",
    }] : []),
    {
      header: "accounting.commission_target.table.target_amount_header",
      accessorKey: "amount",
      visible: true,
      type: "amount",
    },
    ...(isDevSpar ? [
      {
        header: "accounting.commission_target.table.achieved_value_header",
        accessorKey: "achieved_value",
        visible: true,
        type: "amount",
      },
      {
        header: "accounting.commission_target.table.pending_to_reach_target_header",
        accessorKey: "pending_to_reach_target",
        visible: true,
        type: "amount",
      },
    ] : []),
  ];
}

export const commissionAssignmentColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.commission_assignment.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission_assignment.table.title_header",
    accessorKey: "title",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission_assignment.table.description_header",
    accessorKey: "description",
    visible: true,
    type: "string",
  },
];

export const monthWiseCommissionColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.month_wise_commission.table.cms_id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.month_wise_commission.table.start_date_header",
    accessorKey: "start_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.month_wise_commission.table.end_date_header",
    accessorKey: "end_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.month_wise_commission.table.department_header",
    accessorKey: "department_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.month_wise_commission.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status"
  },
];

export const commissionAuthorizationColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.authorize_commission.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.authorize_commission.table.salesperson_header",
    accessorKey: "salesperson_data.name",
    visible: true,
    type: "string",
  },
  {
    header:
      "accounting.authorize_commission.table.calculated_commission_header",
    accessorKey: "calculated_commission_amount",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.authorize_commission.table.paid_commission_header",
    accessorKey: "total_authorised_commission",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.authorize_commission.table.commission_amount_header",
    accessorKey: "total_remaining_amount",
    visible: true,
    type: "string",
  },
];

export const commissionColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.commission.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission.table.salesperson_header",
    accessorKey: "salesperson_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission.table.manager_header",
    accessorKey: "manager_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.commission.table.commission_amount_header",
    accessorKey: "total_authorised_commission",
    visible: true,
    type: "string",
    enableSorting: false
  },
];

export const purchaseInvoiceColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.bills.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
  },
  {
    header: "accounting.bills.table.supplier_header",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.bills.table.payment_status_header",
    accessorKey: "payment_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.bills.table.status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.invoice.table.total_invoice_value_header",
    accessorKey: "total_invoice_amount",
    visible: true,
    type: "amount",
    showDefaultCurrency: true
  },
  {
    header: "accounting.invoice.table.party_amount_header",
    accessorKey: "party_amount",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.bills.table.invoice_date_header",
    accessorKey: "bill_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.bills.table.due_date_header",
    accessorKey: "due_date",
    visible: false,
    type: "date",
  },
  {
    header: "accounting.bills.table.payment_amount_header",
    accessorKey: "amount_paid",
    visible: false,
    type: "number",
  },
  {
    header: "accounting.bills.table.currency_header",
    accessorKey: "supplier_currency_data.currency_name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.bills.table.company_header",
    accessorKey: "company_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.bills.table.exchange_rate_header",
    accessorKey: "exchange_rate",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.bills.table.incoterm_header",
    accessorKey: "incoterm_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.bills.table.additional_discount_on_header",
    accessorKey: "additional_discount_on",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.bills.table.additional_discount_percentage_header",
    accessorKey: "additional_discount_percentage",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.bills.table.additional_discount_amount_header",
    accessorKey: "additional_discount_amount",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.bills.table.round_off_header",
    accessorKey: "round_off_amount",
    visible: false,
    type: "boolean",
  },
];

export const salesInvoiceColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.invoice.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.invoice.table.customer_header",
    accessorKey: "customer_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.invoice.table.payment_status_header",
    accessorKey: "payment_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.invoice.table.status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.invoice.table.total_invoice_value_header",
    accessorKey: "total_invoice_amount",
    visible: true,
    type: "amount",
    showDefaultCurrency: true
  },
  {
    header: "accounting.invoice.table.party_amount_header",
    accessorKey: "party_amount",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.invoice.table.due_date_header",
    accessorKey: "due_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.invoice.table.currency_header",
    accessorKey: "currency_data.currency_name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.invoice.table.company_header",
    accessorKey: "company_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.invoice.table.exchange_rate_header",
    accessorKey: "exchange_rate",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.invoice.table.incoterm_header",
    accessorKey: "incoterm_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.invoice.table.additional_discount_on_header",
    accessorKey: "additional_discount_on",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.invoice.table.additional_discount_percentage_header",
    accessorKey: "additional_discount_percentage",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.invoice.table.additional_discount_amount_header",
    accessorKey: "additional_discount_amount",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.invoice.table.round_off_header",
    accessorKey: "round_off",
    visible: false,
    type: "boolean",
  },
];

export const cashExpensesColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.expenses.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
  },
  {
    header: "accounting.expenses.table.supplier_header",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.expenses.table.payment_status_header",
    accessorKey: "payment_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.expenses.table.status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.invoice.table.total_invoice_value_header",
    accessorKey: "total_invoice_amount",
    visible: true,
    type: "amount",
    showDefaultCurrency: true
  },
  {
    header: "accounting.invoice.table.party_amount_header",
    accessorKey: "party_amount",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.expenses.table.invoice_date_header",
    accessorKey: "bill_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.expenses.table.due_date_header",
    accessorKey: "due_date",
    visible: false,
    type: "date",
  },
  {
    header: "accounting.expenses.table.payment_amount_header",
    accessorKey: "amount_paid",
    visible: false,
    type: "number",
  },
  {
    header: "accounting.expenses.table.currency_header",
    accessorKey: "supplier_currency_data.currency_name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.expenses.table.company_header",
    accessorKey: "company_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.expenses.table.exchange_rate_header",
    accessorKey: "exchange_rate",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.expenses.table.incoterm_header",
    accessorKey: "incoterm_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.expenses.table.additional_discount_on_header",
    accessorKey: "additional_discount_on",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.expenses.table.additional_discount_percentage_header",
    accessorKey: "additional_discount_percentage",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.expenses.table.additional_discount_amount_header",
    accessorKey: "additional_discount_amount",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.expenses.table.round_off_header",
    accessorKey: "round_off",
    visible: false,
    type: "boolean",
  },
];

export const creditNoteColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.credit_note.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.credit_note.table.party_header",
    accessorKey: "party",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.credit_note.table.party_name_header",
    accessorKey: "party_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.credit_note.table.credit_note_header",
    accessorKey: "credit_note_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.credit_note.table.amount_header",
    accessorKey: "amount",
    visible: true,
    type: "amount",
    showDefaultCurrency: true
  },
  {
    header: "accounting.credit_note.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];

export const debitNoteColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.debit_note.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.debit_note.table.party_header",
    accessorKey: "party",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.debit_note.table.party_name_header",
    accessorKey: "party_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.debit_note.table.debit_note_header",
    accessorKey: "debit_note_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.debit_note.table.amount_header",
    accessorKey: "amount",
    visible: true,
    type: "amount",
    showDefaultCurrency: true
  },
  {
    header: "accounting.debit_note.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
  {
    header: "accounting.debit_note.table.invoice_header",
    accessorKey: "invoice_entries",
    visible: true,
    type: "array",
    typeArrayAccessorKey: "series_number",
  },
];

export const expenseReimbursementColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.expense_reimbursement.table.expense_date_header",
    accessorKey: "transaction_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.expense_reimbursement.table.reference_number_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.expense_reimbursement.table.paid_by_header",
    accessorKey: "paid_by",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.expense_reimbursement.table.total_amount_header",
    accessorKey: "total_amount",
    visible: true,
    type: "amount",
    showDefaultCurrency: true
  },
  {
    header: "accounting.expense_reimbursement.table.description_header",
    accessorKey: "description",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.expense_reimbursement.table.status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.expense_reimbursement.table.payment_status_header",
    accessorKey: "payment_status",
    visible: true,
    type: "custom",
  },
];

export const expenseReportsColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.expense_report.table.expense_date_header",
    accessorKey: "transaction_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.expense_report.table.reference_number_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.expense_report.table.paid_by_header",
    accessorKey: "paid_by",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.expense_report.table.total_amount_header",
    accessorKey: "total_amount",
    visible: true,
    type: "amount",
  },
  {
    header: "accounting.expense_report.table.description_header",
    accessorKey: "description",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.expense_report.table.status_header",
    accessorKey: "approval_status",
    visible: true,
    type: "custom",
  },
];

export const chartOfAccountsColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.coa.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
    size: 100,
  },
  {
    header: "accounting.coa.table.account_code_header",
    accessorKey: "account_code",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.coa.table.account_name_header",
    accessorKey: "account_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.coa.table.status_header",
    accessorKey: "is_active",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.coa.table.account_type_header",
    accessorKey: "account_type.name",
    visible: true,
    type: "string",
  },
];

export const currencyColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.currency.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.currency.table.currency_name_header",
    accessorKey: "currency_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.currency.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.currency.table.fraction_header",
    accessorKey: "fraction",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.currency.table.fraction_unit_header",
    accessorKey: "fraction_unit",
    visible: true,
    type: "string",
  },
];

export const journalTypeColumns: MaterialTableColumnProps[] = [
  {
    header: "ID",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "Name",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "Is Payment",
    accessorKey: "is_payment",
    visible: true,
    type: "boolean",
    typeBooleanLabels: {
      0: 'No',
      1: 'Yes',
      true: 'Yes',
      false: 'No'
    }
  },
  {
    header: "Created At",
    accessorKey: "created_at",
    visible: true,
    type: "date",
  },
];

export const currencyExchangeColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.currencyExchange.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
  },
  {
    header: "accounting.currencyExchange.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.currencyExchange.table.from_currency_header",
    accessorKey: "from_currency_data.currency_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.currencyExchange.table.to_currency_header",
    accessorKey: "to_currency_data.currency_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.currencyExchange.table.exchange_rate_header",
    accessorKey: "exchange_rate",
    visible: true,
    type: "number",
  },
];

export const taxCategoryColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.taxCategory.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxCategory.table.date_header",
    accessorKey: "created_at",
    visible: false,
    type: "date",
  },
  {
    header: "accounting.taxCategory.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxCategory.table.sales_account_header",
    accessorKey: "sales_account_data.acc_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxCategory.table.purchase_account_header",
    accessorKey: "purchase_account_data.acc_name",
    visible: true,
    type: "string",
  },
];

export const taxCodeColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.taxCode.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxCode.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxCode.table.rate_header",
    accessorKey: "rate",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxCode.table.effective_start_date_header",
    accessorKey: "effective_start_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.taxCode.table.effective_end_date_header",
    accessorKey: "effective_end_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.taxCode.table.tax_category_header",
    accessorKey: "tax_category.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxCode.table.applies_to_header",
    accessorKey: "applies_to",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.taxCode.table.reverse_charge_code_header",
    accessorKey: "reverse_charge_code_data.name",
    visible: false,
    type: "string",
  },
  {
    header: "accounting.taxCode.table.description_header",
    accessorKey: "description",
    visible: false,
    type: "string",
  },
];

export const taxTemplateColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.taxTemplate.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxTemplate.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.taxTemplate.table.tax_code_header",
    accessorKey: "tax_codes",
    visible: true,
    type: "string",
    enableSorting: false
  },
];


export const bankColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.bank.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.bank.table.bank_name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.bank.table.swift_number_header",
    accessorKey: "swift_number",
    visible: true,
    type: "string",
  },
];

export const bankAccountColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.bankAccount.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.bankAccount.table.account_number_header",
    accessorKey: "account_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.bankAccount.table.bank_name_header",
    accessorKey: "bank_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.bankAccount.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.bankAccount.table.account_type_header",
    accessorKey: "type_data.name",
    visible: true,
    type: "string",
  },
];
export const fiscalYearColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.fiscalYear.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.fiscalYear.table.year_name_header",
    accessorKey: "year_name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.fiscalYear.table.year_start_date_header",
    accessorKey: "year_start_date",
    visible: true,
    type: "date",
  },
  {
    header: "accounting.fiscalYear.table.year_end_date_header",
    accessorKey: "year_end_date",
    visible: true,
    type: "date",
  },
];

export const paymentTermsColumns: MaterialTableColumnProps[] = [
  {
    header: "accounting.paymentTerm.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.paymentTerm.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.paymentTerm.table.due_date_based_on_header",
    accessorKey: "due_date_data.value",
    visible: true,
    type: "string",
  },
  {
    header: "accounting.paymentTerm.table.credit_days_header",
    accessorKey: "credit_days",
    visible: true,
    type: "custom",
  },
  {
    header: "accounting.paymentTerm.table.mode_of_payment_header",
    accessorKey: "mode_of_payment",
    visible: true,
    type: "string",
  },
];


export const inventoryItemColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.item.table.sku_header",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.item.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.item.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "inventory.item.table.cost_header",
    accessorKey: "cost",
    visible: true,
    type: "amount",
  },
  {
    header: "inventory.item.table.sales_price_header",
    accessorKey: "sales_price",
    visible: true,
    type: "amount",
  },
  {
    header: "inventory.item.table.total_available_quantity_header",
    accessorKey: "total_available_quantity",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.item.table.unit_of_measurement_header",
    accessorKey: "stock_unit_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.item.table.category_header",
    accessorKey: "category_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "Daily Rate",
    accessorKey: "daily_rate",
    visible: false,
    type: "amount",
  },
];

export const itemCategoryColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.itemCategory.table.category_header",
    accessorKey: "category_name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.itemCategory.table.parent_header",
    accessorKey: "parent_category_data.name",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "inventory.itemCategory.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "inventory.itemCategory.table.level_header",
    accessorKey: "level",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.itemCategory.table.sub_categories_header",
    accessorKey: "subcategory_count",
    visible: true,
    type: "string",
  },
];

export const discountedItemsColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.discountedItem.table.sku_header",
    accessorKey: "sku_number",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.discountedItem.table.discounted_item_header",
    accessorKey: "discount_type",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.discountedItem.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.discountedItem.table.account_header",
    accessorKey: "account_data.account_name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.discountedItem.table.tax_account_header",
    accessorKey: "tax_account_data.account_name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.discountedItem.table.discount_rate_header",
    accessorKey: "discount_rate_amount",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.discountedItem.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const attributesColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.attribute.table.attribute_header",
    accessorKey: "attribute_name",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "inventory.attribute.table.variants_creation_mode_header",
    accessorKey: "variants_creation_mode",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.attribute.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const locationColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.location.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.location.table.address_header",
    accessorKey: "address1",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.location.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.location.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const routeRulesColumns: MaterialTableColumnProps[] = [
  {
    header: "Route Name",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "Company",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "Status",
    accessorKey: "is_active",
    visible: true,
    type: "custom",
  },
];

export const binsColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.bin.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin.table.location_header",
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin.table.bin_type_header",
    accessorKey: "bin_type",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const uomColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.unit_of_measurement.table.unit_name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.unit_of_measurement.table.symbol_header",
    accessorKey: "abbreviation",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.unit_of_measurement.table.base_unit_header",
    accessorKey: "base_symbol",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "inventory.unit_of_measurement.table.status_header",
    accessorKey: "is_active",
    visible: true,
    type: "custom",
  },
];

export const stockTransferColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.stock_transfer.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.stock_transfer.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.stock_transfer.table.source_location_header",
    accessorKey: "source_location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.stock_transfer.table.destination_location_header",
    accessorKey: "destination_location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.stock_transfer.table.contact_person_header",
    accessorKey: "employee_data",
    visible: true,
    type: "custom",
  },
  {
    header: "inventory.stock_transfer.table.scheduled_date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "inventory.stock_transfer.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const binTransferColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.bin_transfer.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin_transfer.table.location_header",
    accessorKey: "warehouse_location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin_transfer.table.source_bin_header",
    accessorKey: "source_bin_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin_transfer.table.destination_bin_header",
    accessorKey: "destination_bin_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin_transfer.table.contact_person_header",
    accessorKey: "contact_data.first_name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin_transfer.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "inventory.bin_transfer.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.bin_transfer.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const scrapColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.scrap.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.scrap.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.scrap.table.destination_location_header",
    accessorKey: "destination_location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.scrap.table.contact_person_header",
    accessorKey: "employee_data.first_name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.scrap.table.scheduled_date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "inventory.scrap.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const inventoryAdjustmentColumns: MaterialTableColumnProps[] = [
  {
    header: "inventory.inventory_adjustment.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "custom",
  },
  {
    header: "inventory.inventory_adjustment.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.inventory_adjustment.table.account_header",
    accessorKey: "account_data.account_name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.inventory_adjustment.table.reason_header",
    accessorKey: "reason_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "inventory.inventory_adjustment.table.narration_header",
    accessorKey: "narration",
    visible: true,
    type: "string",
  },
];

// Inventory Report Columns
export const inventoryAgingReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "Last Movement Date",
    accessorKey: "last_movement_date",
    visible: true,
    type: "string",
  },
  {
    header: "Days Since Last Movement",
    accessorKey: "days_since_last_movement",
    visible: true,
    type: "number",
  },
  {
    header: "Qty On Hand",
    accessorKey: "qty_on_hand",
    visible: true,
    type: "number",
  },
  {
    header: "Location",
    accessorKey: "location",
    visible: true,
    type: "string",
  },
  {
    header: "Age Bucket",
    accessorKey: "age_bucket",
    visible: true,
    type: "string",
  },
];

export const inventoryCostAnalysisReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "Location",
    accessorKey: "location",
    visible: true,
    type: "string",
  },
  {
    header: "Category",
    accessorKey: "category",
    visible: true,
    type: "string",
  },
  {
    header: "Qty On Hand",
    accessorKey: "qty_on_hand",
    visible: true,
    type: "number",
  },
  {
    header: "Unit Cost",
    accessorKey: "unit_cost",
    visible: true,
    type: "number",
  },
  {
    header: "Total Cost",
    accessorKey: "total_cost",
    visible: true,
    type: "number",
  },
  {
    header: "Valuation Method",
    accessorKey: "valuation_method",
    visible: true,
    type: "string",
  },
  {
    header: "Period",
    accessorKey: "period",
    visible: true,
    type: "string",
  },
];

export const returnToVendorReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Return ID",
    accessorKey: "return_id",
    visible: true,
    type: "string",
  },
  {
    header: "Original Order ID",
    accessorKey: "original_order_po_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "Quantity",
    accessorKey: "qty",
    visible: true,
    type: "number",
  },
  {
    header: "Return Type",
    accessorKey: "return_type",
    visible: true,
    type: "string",
  },
  {
    header: "Vendor/Customer Name",
    accessorKey: "vendor_customer_name",
    visible: true,
    type: "string",
  },
  {
    header: "Return Date",
    accessorKey: "return_date",
    visible: true,
    type: "date",
  },
  {
    header: "Location",
    accessorKey: "warehouse",
    visible: true,
    type: "string",
  },
  {
    header: "Status",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
  {
    header: "Cost Impact",
    accessorKey: "cost_impact",
    visible: true,
    type: "number",
  },
  {
    header: "Reason",
    accessorKey: "reason",
    visible: true,
    type: "string",
  },
];

export const slowMovingInventoryReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "Qty On Hand",
    accessorKey: "qty_on_hand",
    visible: true,
    type: "number",
  },
  {
    header: "Last Movement Date",
    accessorKey: "last_movement_date",
    visible: true,
    type: "string",
  },
  {
    header: "Days Since Last Movement",
    accessorKey: "days_since_last_movement",
    visible: true,
    type: "number",
  },
  {
    header: "Warehouse ID",
    accessorKey: "warehouse_id",
    visible: false,
    type: "string",
  },
  {
    header: "Location",
    accessorKey: "warehouse_name",
    visible: true,
    type: "string",
  },
  {
    header: "Category",
    accessorKey: "category",
    visible: true,
    type: "string",
  },
  {
    header: "Sales History",
    accessorKey: "sales_history",
    visible: true,
    type: "number",
  },
];

export const stockMovementTurnoverReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "Location",
    accessorKey: "warehouse",
    visible: true,
    type: "string",
  },
  {
    header: "Period Start",
    accessorKey: "period_start",
    visible: true,
    type: "string",
  },
  {
    header: "Period End",
    accessorKey: "period_end",
    visible: true,
    type: "string",
  },
  {
    header: "In Quantity",
    accessorKey: "in_qty",
    visible: true,
    type: "number",
  },
  {
    header: "Out Quantity",
    accessorKey: "out_qty",
    visible: true,
    type: "number",
  },
  {
    header: "Net Change",
    accessorKey: "net_change",
    visible: true,
    type: "number",
  },
  {
    header: "Opening Stock",
    accessorKey: "opening_stock",
    visible: true,
    type: "number",
  },
  {
    header: "Closing Stock",
    accessorKey: "closing_stock",
    visible: true,
    type: "number",
  },
  {
    header: "Turnover Rate",
    accessorKey: "turnover_rate",
    visible: true,
    type: "number",
  },
];

export const stockOnHandReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "Lot/Serial",
    accessorKey: "lot_serial",
    visible: true,
    type: "string",
  },
  {
    header: "Location",
    accessorKey: "warehouse",
    visible: true,
    type: "string",
  },
  {
    header: "Bin Location",
    accessorKey: "bin_location",
    visible: true,
    type: "string",
  },
  {
    header: "Stock Qty On Hand",
    accessorKey: "stock_qty_on_hand",
    visible: true,
    type: "number",
  },
  {
    header: "Unit of Measure",
    accessorKey: "unit_of_measure",
    visible: true,
    type: "string",
  },
  {
    header: "Valuation Price",
    accessorKey: "valuation_price",
    visible: true,
    type: "number",
  },
  {
    header: "Total Value",
    accessorKey: "total_value",
    visible: true,
    type: "number",
  },
  {
    header: "Report Date",
    accessorKey: "report_date",
    visible: true,
    type: "string",
  },
];

export const stockReconciliationReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "Location ID",
    accessorKey: "location_id",
    visible: true,
    type: "string",
  },
  {
    header: "Location",
    accessorKey: "location_name",
    visible: false,
    type: "string",
  },
  {
    header: "System Qty",
    accessorKey: "system_qty",
    visible: true,
    type: "number",
  },
  {
    header: "Physical Count",
    accessorKey: "physical_count",
    visible: true,
    type: "number",
  },
  {
    header: "Variance",
    accessorKey: "variance",
    visible: true,
    type: "number",
  },
  {
    header: "Variance %",
    accessorKey: "variance_percent",
    visible: true,
    type: "number",
  },
  {
    header: "Reconciliation Date",
    accessorKey: "reconciliation_date",
    visible: true,
    type: "string",
  },
  {
    header: "User Name",
    accessorKey: "user_name",
    visible: true,
    type: "string",
  },
];

export const stockReservationReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "Reserved Qty",
    accessorKey: "reserved_qty",
    visible: true,
    type: "number",
  },
  {
    header: "Order ID",
    accessorKey: "order_id",
    visible: true,
    type: "string",
  },
  {
    header: "Customer Name",
    accessorKey: "customer_name",
    visible: true,
    type: "string",
  },
  {
    header: "Salesperson Name",
    accessorKey: "salesperson_name",
    visible: true,
    type: "string",
  },
  {
    header: "Reservation Date",
    accessorKey: "reservation_date",
    visible: true,
    type: "string",
  },
  {
    header: "Location",
    accessorKey: "location",
    visible: true,
    type: "string",
  },
  {
    header: "Status",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];

export const warehouseStockAgingReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "Warehouse ID",
    accessorKey: "warehouse_id",
    visible: false,
    type: "string",
  },
  {
    header: "Location",
    accessorKey: "warehouse_name",
    visible: true,
    type: "string",
  },
  {
    header: "Bin ID",
    accessorKey: "bin_id",
    visible: true,
    type: "string",
  },
  {
    header: "Stock Qty",
    accessorKey: "stock_qty",
    visible: true,
    type: "number",
  },
  {
    header: "Last Movement Date",
    accessorKey: "last_movement_date",
    visible: true,
    type: "date",
  },
  {
    header: "Days In Location",
    accessorKey: "days_in_location",
    visible: true,
    type: "number",
  },
  {
    header: "Age Bucket",
    accessorKey: "age_bucket",
    visible: true,
    type: "string",
  },
];

export const warehouseTransfersReportColumns: MaterialTableColumnProps[] = [
  {
    header: "Transfer ID",
    accessorKey: "transfer_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product ID",
    accessorKey: "product_id",
    visible: true,
    type: "string",
  },
  {
    header: "Product Name",
    accessorKey: "product_name",
    visible: true,
    type: "string",
  },
  {
    header: "SKU",
    accessorKey: "sku",
    visible: true,
    type: "string",
  },
  {
    header: "From Location",
    accessorKey: "from_warehouse",
    visible: true,
    type: "string",
  },
  {
    header: "To Location",
    accessorKey: "to_warehouse",
    visible: true,
    type: "string",
  },
  {
    header: "Quantity",
    accessorKey: "qty",
    visible: true,
    type: "number",
  },
  {
    header: "Transfer Date",
    accessorKey: "transfer_date",
    visible: true,
    type: "date",
  },
  {
    header: "Operator",
    accessorKey: "operator",
    visible: true,
    type: "string",
  },
  {
    header: "Status",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];

export const billOfMaterialColumns: MaterialTableColumnProps[] = [
  {
    header: 'manufacturing.bom.table.id_header',
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.bom.table.bom_name_header',
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.bom.table.product_header',
    accessorKey: "item_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.bom.table.version_number_header',
    accessorKey: "version_number",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.bom.table.status_header',
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const gateRegisterColumns: MaterialTableColumnProps[] = [
  {
    header: 'manufacturing.gate.table.id_header',
    accessorKey: 'series_number',
    visible: true,
    type: 'string'
  },
  {
    header: 'manufacturing.gate.table.date_header',
    accessorKey: 'record_date',
    visible: true,
    type: 'date'
  },
  {
    header: 'manufacturing.gate.table.vehicle_header',
    accessorKey: 'vehicle_number_data.number',
    visible: true,
    type: 'string'
  },
  {
    header: 'manufacturing.gate.table.driver_header',
    accessorKey: 'driver_name',
    visible: true,
    type: 'string'
  },
  {
    header: 'manufacturing.gate.table.entry_date_time_header',
    accessorKey: 'entry_datetime',
    visible: true,
    type: "custom"
  },
  {
    header: 'manufacturing.gate.table.exit_date_time_header',
    accessorKey: 'exit_datetime',
    visible: true,
    type: "custom"
  },
];

export const jobCardsColumns: MaterialTableColumnProps[] = [
  {
    header: "manufacturing.jobCards.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.jobCards.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "manufacturing.jobCards.table.Company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.jobCards.table.Location_header",
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.jobCards.table.Item_header",
    accessorKey: "item_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.jobCards.table.Material_status_header",
    accessorKey: "material_status",
    visible: true,
    type: "custom",
  },
  {
    header: "manufacturing.jobCards.table.uom_header",
    accessorKey: "uom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.jobCards.table.bom_header",
    accessorKey: "bom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.jobCards.table.quantity_header",
    accessorKey: "quantity",
    visible: true,
    type: "number",
  },
  {
    header: "manufacturing.jobCards.table.routing_header",
    accessorKey: "routing_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.jobCards.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const workOrderColumns: MaterialTableColumnProps[] = [
  {
    header: "manufacturing.workOrder.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
    size: 70,
  },
  {
    header: "manufacturing.workOrder.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
    size: 140,
  },
  {
    header: "manufacturing.workOrder.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workOrder.table.location_header",
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workOrder.table.item_header",
    accessorKey: "item_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workOrder.table.material_status_header",
    accessorKey: "material_status",
    visible: true,
    type: "custom",
  },
  {
    header: "manufacturing.workOrder.table.unit_of_measurement_header",
    accessorKey: "uom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workOrder.table.bill_of_materials_header",
    accessorKey: "bom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workOrder.table.quantity_text_header",
    accessorKey: "quantity",
    visible: true,
    type: "number",
  },
  {
    header: "manufacturing.workOrder.table.routing_text_label",
    accessorKey: "routing_data.name",
    visible: true,
    type: "number",
  },
  {
    header: "manufacturing.workOrder.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  ...(import.meta.env.VITE_APP_ENV=='spar' ? [{
    header: "manufacturing.workOrder.table.category_header",
    accessorKey: "type",
    visible: true,
    type: "string",
  }] : []),
];

export const buildOrderColumns: MaterialTableColumnProps[] = [
  {
    header: "manufacturing.buildOrder.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.buildOrder.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "manufacturing.buildOrder.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.buildOrder.table.location_header",
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.buildOrder.table.item_header",
    accessorKey: "item_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.buildOrder.table.uom_header",
    accessorKey: "uom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.buildOrder.table.bom_header",
    accessorKey: "bom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.buildOrder.table.quantity_header",
    accessorKey: "quantity",
    visible: true,
    type: "number",
  },
  {
    header: "manufacturing.buildOrder.table.routing_header",
    accessorKey: "routing_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.buildOrder.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const unBuildOrderColumns: MaterialTableColumnProps[] = [
  {
    header: "manufacturing.unbuildOrder.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.unbuildOrder.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "manufacturing.unbuildOrder.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.unbuildOrder.table.location_header",
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.unbuildOrder.table.item_header",
    accessorKey: "item_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.unbuildOrder.table.uom_header",
    accessorKey: "uom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.unbuildOrder.table.bom_header",
    accessorKey: "bom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.unbuildOrder.table.quantity_header",
    accessorKey: "quantity_to_unbuild",
    visible: true,
    type: "number",
  },
  {
    header: "manufacturing.unbuildOrder.table.routing_header",
    accessorKey: "routing_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.unbuildOrder.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const workOrderOperationsColumns: MaterialTableColumnProps[] = [
  {
    header: "manufacturing.manageOperation.table.work_order_header",
    accessorKey: "job_card_data.series_number",
    visible: true,
    type: "string",
    size: 70,
  },
  {
    header: "manufacturing.manageOperation.table.bom_header",
    accessorKey: "job_card_data.bom_data.name",
    visible: true,
    type: "string",
    size: 140,
  },
  {
    header: "manufacturing.manageOperation.table.sequence_header",
    accessorKey: "operation_sequence",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.manageOperation.table.raw_materials_header",
    accessorKey: "rawMaterials",
    visible: true,
    type: "custom",
    size: 350,
  },
  {
    header: "manufacturing.manageOperation.table.operation_person_header",
    accessorKey: "operation_person_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.manageOperation.table.equipment_header",
    accessorKey: "equipment_ids",
    visible: true,
    type: "custom",
    size: 350,
  },
  {
    header: "manufacturing.manageOperation.table.work_center_header",
    accessorKey: "work_centre_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.manageOperation.table.schedule_start_date_header",
    accessorKey: "scheduled_start_date",
    visible: true,
    type: "date",
  },
  {
    header: "manufacturing.manageOperation.table.expected_labor_header",
    accessorKey: "expected_labour",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.manageOperation.table.expected_duration_header",
    accessorKey: "expected_duration",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.manageOperation.table.actual_duration_header",
    accessorKey: "actual_duration",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.manageOperation.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "manufacturing.manageOperation.table.instruction_header",
    accessorKey: "instructions",
    visible: true,
    type: "custom",
  },
  {
    header: "",
    accessorKey: "",
    visible: false,
    type: "actions",
    enableEditing: false,
    size: 70,
  },
];

export const operationBlocksColumns: MaterialTableColumnProps[] = [
  {
    header: "manufacturing.operationBlock.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
    editVariant: "select",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.id_header",
      valueKey: "id",
      field_name: "id",
      validations: [
        {
          type: "required",
          value: true,
          msg_en: "Field is required",
          msg_ar: "Field is required",
        },
      ],
    },
  },
  {
    header: "manufacturing.operationBlock.table.block_reason_header",
    accessorKey: "block_reason",
    visible: true,
    type: "string",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.block_reason_header",
      valueKey: "block_reason",
      field_name: "block_reason",
      disable: true,
    },
  },
  {
    header: "manufacturing.operationBlock.table.start_Date_header",
    accessorKey: "start_date_time",
    visible: true,
    type: "date",
    editVariant: "date",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.start_Date_header",
      valueKey: "start_date_time",
      field_name: "startDateTime",
      validations: [
        {
          type: "required",
          value: true,
          msg_en: "Field is required",
          msg_ar: "Field is required",
        },
      ],
    },
  },
  {
    header: "manufacturing.operationBlock.table.end_Date_header",
    accessorKey: "end_date_time",
    visible: true,
    type: "date",
    editVariant: "date",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.end_Date_header",
      valueKey: "end_date_time",
      field_name: "endDateTime",
      validations: [
        {
          type: "required",
          value: true,
          msg_en: "Field is required",
          msg_ar: "Field is required",
        },
      ],
    },
  },
  {
    header: "manufacturing.operationBlock.table.work_center_header",
    accessorKey: "work_centre_data.name",
    visible: true,
    type: "string",
    editVariant: "select",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.work_center_header",
      valueKey: "unit_of_measurement_id",
      field_name: "workCentre",
      validations: [
        {
          type: "required",
          value: true,
          msg_en: "Field is required",
          msg_ar: "Field is required",
        },
      ],
    },
  },
  {
    header: "manufacturing.operationBlock.table.assigner_user_header",
    accessorKey: "assigned_user_data.name",
    visible: true,
    type: "string",
    editVariant: "string",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.assigner_user_header",
      field_name: "assignedUser",
    },
  },
  {
    header: "manufacturing.operationBlock.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
    editVariant: "string",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.company_header",
      field_name: "company",
    },
  },
  {
    header: "manufacturing.operationBlock.table.description_header",
    accessorKey: "description",
    visible: true,
    type: "string",
    editVariant: "string",
    editProperties: {
      placeholder: "manufacturing.operationBlock.table.description_header",
      field_name: "description",
    },
  },
];

export const equipmentFailureColumns: MaterialTableColumnProps[] = [
  {
    header: 'manufacturing.failure.table.id_header',
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.failure.table.equipmentName_header',
    accessorKey: "equipment_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.failure.table.startDate_header',
    accessorKey: "start_date",
    visible: true,
    type: "date",
  },
  {
    header: 'manufacturing.failure.table.endDate_header',
    accessorKey: "end_date",
    visible: true,
    type: "date",
  },
  {
    header: 'manufacturing.failure.table.workCentre_header',
    accessorKey: "work_centre_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.failure.table.assignedUser_header',
    accessorKey: "assigned_user_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.failure.table.description_header',
    accessorKey: "narration",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.failure.table.duration_header',
    accessorKey: "duration",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.failure.table.company_header',
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.failure.table.maintenanceStatus_header',
    accessorKey: "maintenance_status",
    visible: true,
    type: "custom",
  },
];

export const operationsColumns: MaterialTableColumnProps[] = [
  {
    header: 'manufacturing.operation.table.id_header',
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.operation.table.operationName_header',
    accessorKey: "operation_name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.operation.table.workCentre_header',
    accessorKey: "work_centre_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.operation.table.actualDurationComputation_header',
    accessorKey: "duration_computation",
    visible: true,
    type: "string",
    enableSorting: false,
  },
  {
    header: 'manufacturing.operation.table.defaultDuration_header',
    accessorKey: "default_duration",
    visible: true,
    type: "string",
  },

];

export const workCenterColumns: MaterialTableColumnProps[] = [
  {
    header: "manufacturing.workCentre.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workCentre.table.workCentre_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workCentre.table.workCentreCode_header",
    accessorKey: "code",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workCentre.table.alternativeWC_header",
    accessorKey: "alternative_wc_data.name",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "manufacturing.workCentre.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "manufacturing.workCentre.table.capacity_header",
    accessorKey: "capacity",
    visible: true,
    type: "number",
  },
];

export const equipmentColumns: MaterialTableColumnProps[] = [
  {
    header: 'manufacturing.equipments.table.id_header',
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.equipments.table.equipmentName_header',
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.equipments.table.equipmentCategory_header',
    accessorKey: "equipment_category_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.equipments.table.workCentre_header',
    accessorKey: "work_centre_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.equipments.table.narration_header',
    accessorKey: "narration",
    visible: true,
    type: "string",
  },
];

export const workCenterCategoriesColumns: MaterialTableColumnProps[] = [
  {
    header: 'manufacturing.workCentreCategories.table.id_header',
    accessorKey: "series_number",
    visible: true,
    type: "string",
    size: 30,
  },
  {
    header: 'manufacturing.workCentreCategories.table.categoryName_header',
    accessorKey: "name",
    visible: true,
    type: "string",
    size: 80,
  },
  {
    header: 'manufacturing.workCentreCategories.table.item_header',
    accessorKey: "item_data.name",
    visible: true,
    type: "string",
    size: 80,
  },
  {
    header: 'manufacturing.workCentreCategories.table.narration_header',
    accessorKey: "narration",
    visible: true,
    type: "string",
  },
];
export const routingColumns: MaterialTableColumnProps[] = [
  {
    header: 'manufacturing.routing.table.id_header',
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.routing.table.date_header',
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: 'manufacturing.routing.table.name_header',
    accessorKey: "route_name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.routing.table.item_header',
    accessorKey: "item_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.routing.table.bom_header',
    accessorKey: "bom_data.name",
    visible: true,
    type: "string",
  },
  {
    header: 'manufacturing.routing.table.location_header',
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
];
export const leadColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.leads.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "crm.leads.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: 'crm.leads.table.company_header',
    accessorKey: 'companies_data',
    visible: true,
    type: 'array',
    typeArrayAccessorKey: 'name',
    custom_class: 'leads--StatusChip--company'
  },
  {
    header: "crm.leads.table.lead_status_header",
    accessorKey: "sales_lead_status",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.leads.table.owner_header",
    accessorKey: "sales_lead_owner_salesperson_data.name",
    visible: true,
    type: "owner",
  },
  {
    header: "crm.leads.table.source_header",
    accessorKey: "sales_source",
    visible: true,
    type: "string",
  },
  {
    header: "crm.leads.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.leads.table.contact_header",
    accessorKey: "contact_no",
    visible: true,
    type: "string",
  },
  {
    header: "crm.leads.table.credit_limit_header",
    accessorKey: "credit_limit",
    visible: true,
    type: "custom",
  },

];

export const opportunityColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.opportunity.table.id_header",
    accessorKey: "party.series_number",
    visible: true,
    type: "string",
  },
  {
    header: "crm.opportunity.table.customer_header",
    accessorKey: "party.name",
    visible: true,
    type: "custom",
    enableSorting: false,
  },
  {
    header: "crm.opportunity.table.company_header",
    accessorKey: "party.sales_person_company",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "crm.opportunity.table.expected_revenue_header",
    accessorKey: "expected_revenue",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.opportunity.table.stage_header",
    accessorKey: "stages",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.opportunity.table.closing_date_header",
    accessorKey: "expected_closing_date",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.opportunity.table.contact_name_header",
    accessorKey: "party_contact_data",
    visible: true,
    type: "custom",
    enableSorting: false,
  },
  {
    header: "crm.opportunity.table.salesperson_header",
    accessorKey: "party.sales_person",
    visible: true,
    type: "string",
    enableSorting: false,
  },
];

export const quotationColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.quotation.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "custom_link",
  },
  {
    header: "crm.quotation.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "crm.quotation.table.customer_header",
    accessorKey: "customer_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.quotation.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.quotation.table.salesperson_header",
    accessorKey: "salesperson_data.name",
    visible: true,
    type: "string",
  },

  {
    header: "crm.quotation.table.company_name_header",
    accessorKey: "company_data.company_name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.quotation.table.total_value_header",
    accessorKey: "total_amount",
    visible: true,
    type: "currency",
  },
];

export const salesOrderColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.salesOrder.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
    size: 80,
  },
  {
    header: "crm.salesOrder.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "crm.salesOrder.table.customer_header",
    accessorKey: "customer_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.salesOrder.table.salesOrderStatus_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.salesOrder.table.invoiceStatus_header",
    accessorKey: "invoice_status",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.salesOrder.table.deliveryStatus_header",
    accessorKey: "delivery_status",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.salesOrder.table.salesperson_header",
    accessorKey: "salesperson_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.salesOrder.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.salesOrder.table.totalAmount_header",
    accessorKey: "total_amount",
    visible: true,
    type: "currency",
  },
];

export const deliveryOrderColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.deliveryOrder.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
    size: 100,
  },
  {
    header: "crm.deliveryOrder.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "crm.deliveryOrder.table.salesorder_header",
    accessorKey: "sales_order_data.series_number",
    visible: true,
    type: "string",
  },
  {
    header: "crm.deliveryOrder.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "crm.deliveryOrder.table.salesperson_header",
    accessorKey: "salesperson_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.deliveryOrder.table.driver_header",
    accessorKey: "transportation.driver",
    visible: true,
    type: "string",
    enableSorting: false,
  },

  {
    header: "crm.deliveryOrder.table.customer_header",
    accessorKey: "customer_data.name",
    visible: true,
    type: "string",
    enableSorting: false,
  },
  {
    header: "crm.deliveryOrder.table.location_header",
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.deliveryOrder.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
];

export const salesOrderDetailReportColumns: MaterialTableColumnProps[] = [
  { header: "Order", accessorKey: "order_id", visible: true, type: "string" },
  { header: "Order Date", accessorKey: "order_date", visible: true, type: "date" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "Product/Service", accessorKey: "product_service", visible: true, type: "string" },
  { header: "SKU", accessorKey: "item_code", visible: true, type: "string" },
  { header: "Qty", accessorKey: "qty", visible: true, type: "toFixed" },
  { header: "Unit Price", accessorKey: "unit_price", visible: true, type: "toFixed" },
  { header: "Disc Amount", accessorKey: "disc_amount", visible: true, type: "toFixed" },
  { header: "Tax Amount", accessorKey: "tax_amount_field", visible: true, type: "toFixed" },
  { header: "Gross Amount", accessorKey: "gross_amount", visible: true, type: "toFixed" },
  { header: "Tax Template", accessorKey: "tax_template", visible: true, type: "string" },
  { header: "Net Price", accessorKey: "net_price", visible: true, type: "toFixed" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Delivery Date", accessorKey: "delivery_date", visible: true, type: "date" },
  { header: "PO No", accessorKey: "po_no", visible: true, type: "string" },
  { header: "Invoice No", accessorKey: "invoice_no", visible: true, type: "string" },
  { header: "Delivery No", accessorKey: "delivery_no", visible: true, type: "string" },
  { header: "Pending Del Qty", accessorKey: "pending_del_qty", visible: true, type: "toFixed" },
  { header: "Pending Order Value", accessorKey: "pending_order_value", visible: true, type: "toFixed" },
];

export const salesInvoiceSummaryReportColumns: MaterialTableColumnProps[] = [
  { header: "Invoice", accessorKey: "invoice_id", visible: true, type: "string" },
  { header: "Customer ID", accessorKey: "customer_id", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Invoice Date", accessorKey: "invoice_date", visible: true, type: "date" },
  { header: "Due Date", accessorKey: "due_date", visible: true, type: "date" },
  { header: "Sales Order", accessorKey: "sales_order_number", visible: true, type: "string" },
  { header: "Invoice Status", accessorKey: "invoice_status", visible: true, type: "status" },
  { header: "Payment Status", accessorKey: "payment_status", visible: true, type: "status" },
  { header: "Invoice Amount", accessorKey: "total_invoice_amount", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "total_tax", visible: true, type: "toFixed" },
  { header: "Paid Amount", accessorKey: "paid_amount", visible: true, type: "toFixed" },
  { header: "Due Amount", accessorKey: "due_amount", visible: true, type: "toFixed" },
  { header: "Currency", accessorKey: "currency", visible: true, type: "string" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "PO Number", accessorKey: "po_number", visible: true, type: "string" },
  { header: "Delivery NO", accessorKey: "delivery_order_number", visible: true, type: "string" },
];

export const salesInvoiceDetailReportColumns: MaterialTableColumnProps[] = [
  { header: "Invoice No", accessorKey: "invoice_number", visible: true, type: "string" },
  { header: "Sales Order No", accessorKey: "sales_order_number", visible: true, type: "string" },
  { header: "Delivery NO", accessorKey: "delivery_order_number", visible: true, type: "string" },
  { header: "Invoice Date", accessorKey: "invoice_date", visible: true, type: "date" },
  { header: "Due Date", accessorKey: "due_date", visible: true, type: "date" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "Product/Service", accessorKey: "product_service", visible: true, type: "string" },
  { header: "SKU", accessorKey: "item_code", visible: true, type: "string" },
  { header: "Qty", accessorKey: "qty", visible: true, type: "toFixed" },
  { header: "Unit Price", accessorKey: "unit_price", visible: true, type: "toFixed" },
  { header: "Disc Amount", accessorKey: "disc_amount", visible: true, type: "toFixed" },
  { header: "Tax Template", accessorKey: "tax_template", visible: true, type: "string" },
  { header: "Tax Amount", accessorKey: "tax_amount", visible: true, type: "toFixed" },
  { header: "Net Price", accessorKey: "net_price", visible: true, type: "toFixed" },
  { header: "Actual Price", accessorKey: "actual_price", visible: true, type: "toFixed" },
  { header: "Zero Rate Amount", accessorKey: "zero_rate", visible: true, type: "toFixed" },
  { header: "Invoice Status", accessorKey: "invoice_status", visible: true, type: "status" },
  { header: "Payment Status", accessorKey: "payment_status", visible: true, type: "status" },
  { header: "Currency", accessorKey: "currency", visible: true, type: "string" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "PO Number", accessorKey: "po_number", visible: true, type: "string" },
];

export const salesByProductReportColumns: MaterialTableColumnProps[] = [
  { header: "Product", accessorKey: "product", visible: true, type: "string" },
  { header: "Quantity Sold", accessorKey: "quantity_sold", visible: true, type: "number" },
  { header: "Total Sales Value", accessorKey: "total_sales_value", visible: true, type: "number" },
  { header: "Gross Margin", accessorKey: "gross_margin", visible: true, type: "number" },
  { header: "Returns", accessorKey: "return_quantity", visible: true, type: "number" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
];

export const salesOrderSummaryReportColumns: MaterialTableColumnProps[] = [
  { header: "Order", accessorKey: "order_id", visible: true, type: "string" },
  { header: "Customer ID", accessorKey: "customer_id", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Order Date", accessorKey: "order_date", visible: true, type: "date" },
  { header: "Order Status", accessorKey: "order_status", visible: true, type: "status" },
  { header: "Delivery Status", accessorKey: "delivery_status", visible: true, type: "status" },
  { header: "Invoice Status", accessorKey: "invoice_status", visible: true, type: "status" },
  { header: "Payment Status", accessorKey: "payment_status", visible: true, type: "status" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Order Value", accessorKey: "total_order_value", visible: true, type: "toFixed" },
  { header: "Gross Amount", accessorKey: "gross_amount", visible: true, type: "toFixed" },
  { header: "Net Amount", accessorKey: "net_amount", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "total_tax", visible: true, type: "toFixed" },
  { header: "Tax Templates", accessorKey: "tax_templates", visible: true, type: "string" },
  { header: "Invoiced", accessorKey: "invoiced_amount", visible: true, type: "toFixed" },
  { header: "Collected", accessorKey: "collected_amount", visible: true, type: "toFixed" },
  { header: "Balance", accessorKey: "balance_payment", visible: true, type: "toFixed" },
  { header: "Currency", accessorKey: "currency", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "PO Number", accessorKey: "po_number", visible: true, type: "string" },
  { header: "Delivery NO", accessorKey: "delivery_order_number", visible: true, type: "string" },
];

// Procurement Report Columns
export const purchaseOrderSummaryReportColumns: MaterialTableColumnProps[] = [
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "Supplier ID/Name", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "PO Date", accessorKey: "po_date", visible: true, type: "date" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
  { header: "Billing Status", accessorKey: "billing_status", visible: true, type: "status" },
  { header: "Receiving Status", accessorKey: "receiving_status", visible: true, type: "status" },
  { header: "Total Value", accessorKey: "total_value", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "tax_amount", visible: true, type: "toFixed" },
  { header: "Tax Templates", accessorKey: "tax_templates", visible: true, type: "string" },
  { header: "Gross Amount", accessorKey: "gross_value", visible: true, type: "toFixed" },
  { header: "Net Amount", accessorKey: "net_value", visible: true, type: "toFixed" },
  { header: "Currency", accessorKey: "currency", visible: true, type: "string" },
  { header: "Department", accessorKey: "department", visible: true, type: "string" },
  { header: "Expected Delivery Date", accessorKey: "expected_delivery_date", visible: true, type: "date" },
  { header: "GRN No", accessorKey: "grn_numbers", visible: true, type: "string" },
];

export const purchaseOrderDetailReportColumns: MaterialTableColumnProps[] = [
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "PO Date", accessorKey: "po_date", visible: true, type: "date" },
  { header: "Supplier", accessorKey: "supplier", visible: true, type: "string" },
  { header: "Product / Account", accessorKey: "product_or_account", visible: true, type: "string" },
  { header: "Type", accessorKey: "line_type", visible: true, type: "string" },
  { header: "SKU", accessorKey: "sku", visible: true, type: "string" },
  { header: "Quantity", accessorKey: "quantity", visible: true, type: "toFixed" },
  { header: "Unit Price", accessorKey: "unit_price", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "tax", visible: true, type: "toFixed" },
  { header: "Gross Amount", accessorKey: "gross_amount", visible: true, type: "toFixed" },
  { header: "Net Amount", accessorKey: "net_amount", visible: true, type: "toFixed" },
  { header: "Tax Template", accessorKey: "tax_template", visible: true, type: "string" },
  { header: "Discount", accessorKey: "discount", visible: true, type: "toFixed" },
  { header: "Total Line Amount", accessorKey: "total_line_amount", visible: true, type: "toFixed" },
  { header: "Expected Delivery Date", accessorKey: "expected_delivery_date", visible: true, type: "date" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "GRN No", accessorKey: "grn_numbers", visible: true, type: "string" },
];

export const purchaseTrendReportColumns: MaterialTableColumnProps[] = [
  { header: "Period (Month/Quarter/Year)", accessorKey: "period", visible: true, type: "string" },
  { header: "Supplier", accessorKey: "supplier", visible: true, type: "string" },
  { header: "Total Spend", accessorKey: "total_spend", visible: true, type: "toFixed" },
  // { header: "Category", accessorKey: "category", visible: true, type: "string" },
  { header: "Department/Cost Center", accessorKey: "department", visible: true, type: "string" },
  { header: "Number of POs", accessorKey: "number_of_pos", visible: true, type: "toFixed" },
  { header: "Average PO Value", accessorKey: "average_po_value", visible: true, type: "toFixed" },
];

export const purchaseReturnReportColumns: MaterialTableColumnProps[] = [
  { header: "Return ID", accessorKey: "return_id", visible: true, type: "string" },
  { header: "Original PO ID", accessorKey: "original_po_id", visible: true, type: "string" },
  { header: "PO Date", accessorKey: "po_date", visible: true, type: "date" },
  { header: "Supplier", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "Product ID/Name", accessorKey: "product_name", visible: true, type: "string" },
  { header: "SKU", accessorKey: "sku", visible: true, type: "string" },
  { header: "Returned Qty", accessorKey: "returned_qty", visible: true, type: "toFixed" },
  { header: "Return Date", accessorKey: "return_date", visible: true, type: "date" },
  { header: "Credit Amount", accessorKey: "credit_amount", visible: true, type: "toFixed" },
  { header: "Reason", accessorKey: "reason", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Delivery NO", accessorKey: "delivery_order_numbers", visible: true, type: "string" },
];

export const purchaseOrderCancellationReportColumns: MaterialTableColumnProps[] = [
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "Supplier", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "PO Date", accessorKey: "po_date", visible: true, type: "date" },
  { header: "Cancellation Date", accessorKey: "cancellation_date", visible: true, type: "date" },
  { header: "Cancelled Qty", accessorKey: "cancelled_qty", visible: true, type: "toFixed" },
  { header: "Reason", accessorKey: "reason", visible: true, type: "string" },
  { header: "User", accessorKey: "user", visible: true, type: "string" },
  { header: "Department", accessorKey: "department", visible: true, type: "string" },
];

export const approvedVsPendingPoReportColumns: MaterialTableColumnProps[] = [
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "Supplier", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "PO Date", accessorKey: "po_date", visible: true, type: "date" },
  { header: "Approval Status", accessorKey: "approval_status", visible: true, type: "status" },
  { header: "Approved By", accessorKey: "approved_by", visible: true, type: "string" },
  { header: "Pending Approver", accessorKey: "pending_approver", visible: true, type: "string" },
  { header: "Total Value", accessorKey: "total_value", visible: true, type: "toFixed" },
  { header: "Department/Cost Center", accessorKey: "cost_center", visible: true, type: "string" },
  { header: "Expected Delivery Date", accessorKey: "expected_delivery_date", visible: true, type: "date" },
];

export const materialRequirementExceptionReportColumns: MaterialTableColumnProps[] = [
  { header: "Product ID/Name", accessorKey: "product_name", visible: true, type: "string" },
  { header: "Required Qty", accessorKey: "required_qty", visible: true, type: "toFixed" },
  { header: "On-hand Qty", accessorKey: "on_hand_qty", visible: true, type: "toFixed" },
  { header: "On-order Qty", accessorKey: "on_order_qty", visible: true, type: "toFixed" },
  { header: "Shortage Qty", accessorKey: "shortage_qty", visible: true, type: "toFixed" },
  { header: "Recommended Action", accessorKey: "recommended_action", visible: true, type: "string" },
  { header: "Supplier", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
];

export const supplierContractComplianceReportColumns: MaterialTableColumnProps[] = [
  { header: "Supplier", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "Contract ID", accessorKey: "contract_id", visible: true, type: "string" },
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "Order Qty", accessorKey: "order_qty", visible: true, type: "toFixed" },
  { header: "Delivered Qty", accessorKey: "delivered_qty", visible: true, type: "toFixed" },
  { header: "Agreed Price", accessorKey: "agreed_price", visible: true, type: "toFixed" },
  { header: "Actual Price", accessorKey: "actual_price", visible: true, type: "toFixed" },
  { header: "Delivery Date", accessorKey: "delivery_date", visible: true, type: "date" },
  { header: "Compliance %", accessorKey: "compliance_percentage", visible: true, type: "toFixed" },
  { header: "Deviations", accessorKey: "deviations", visible: true, type: "string" },
];

export const supplierRankingScorecardReportColumns: MaterialTableColumnProps[] = [
  { header: "Supplier", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "On-time Delivery %", accessorKey: "on_time_delivery_percentage", visible: true, type: "toFixed" },
  { header: "Quality Score", accessorKey: "quality_score", visible: true, type: "toFixed" },
  { header: "Cost Competitiveness", accessorKey: "avg_unit_price", visible: true, type: "toFixed" },
  { header: "Responsiveness", accessorKey: "responsiveness_score", visible: true, type: "toFixed" },
  { header: "Compliance %", accessorKey: "compliance_percentage", visible: true, type: "toFixed" },
  { header: "Rank", accessorKey: "rank", visible: true, type: "number" },
];

export const receivedVsOrderedReportColumns: MaterialTableColumnProps[] = [
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "Supplier", accessorKey: "supplier", visible: true, type: "string" },
  { header: "Product", accessorKey: "product_name", visible: true, type: "string" },
  { header: "Ordered Quantity", accessorKey: "ordered_quantity", visible: true, type: "toFixed" },
  { header: "Received Quantity", accessorKey: "received_quantity", visible: true, type: "toFixed" },
  { header: "Outstanding Quantity", accessorKey: "outstanding_quantity", visible: true, type: "toFixed" },
  { header: "Receipt Date", accessorKey: "receipt_date", visible: true, type: "date" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
];

export const supplierAgingPayableReportColumns: MaterialTableColumnProps[] = [
  { header: "Supplier ID/Name", accessorKey: "supplier", visible: true, type: "string" },
  { header: "Invoice ID", accessorKey: "invoice_id", visible: true, type: "string" },
  { header: "Invoice Date", accessorKey: "invoice_date", visible: true, type: "date" },
  { header: "Due Date", accessorKey: "due_date", visible: true, type: "date" },
  { header: "Invoice Amount", accessorKey: "invoice_amount", visible: true, type: "toFixed" },
  { header: "Amount Paid", accessorKey: "amount_paid", visible: true, type: "toFixed" },
  { header: "Outstanding Amount", accessorKey: "outstanding_amount", visible: true, type: "toFixed" },
  { header: "Aging Bucket", accessorKey: "aging_bucket", visible: true, type: "string" },
];

export const purchasePriceVarianceReportColumns: MaterialTableColumnProps[] = [
  { header: "Product ID/Name", accessorKey: "product_name", visible: true, type: "string" },
  { header: "Standard Price", accessorKey: "standard_price", visible: true, type: "toFixed" },
  { header: "Ordered Price", accessorKey: "ordered_price", visible: true, type: "toFixed" },
  { header: "Actual Cost", accessorKey: "actual_cost", visible: true, type: "toFixed" },
  { header: "Variance Amount/Percent", accessorKey: "variance_percent", visible: true, type: "toFixed" },
  { header: "Supplier", accessorKey: "supplier", visible: true, type: "string" },
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "Date", accessorKey: "date", visible: true, type: "date" },
];

export const openPurchaseOrderReportColumns: MaterialTableColumnProps[] = [
  { header: "PO ID", accessorKey: "po_id", visible: true, type: "string" },
  { header: "Supplier", accessorKey: "supplier", visible: true, type: "string" },
  { header: "PO Date", accessorKey: "po_date", visible: true, type: "date" },
  { header: "Expected Delivery Date", accessorKey: "expected_delivery_date", visible: true, type: "date" },
  { header: "Outstanding Qty", accessorKey: "outstanding_qty", visible: true, type: "number" },
  { header: "Order Value", accessorKey: "order_value", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "tax_amount", visible: true, type: "toFixed" },
  { header: "Currency", accessorKey: "currency", visible: true, type: "string" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
  { header: "Receiving Status", accessorKey: "receiving_status", visible: true, type: "status" },
  { header: "Department", accessorKey: "department", visible: true, type: "string" },
];

export const purchaseInvoiceSummaryReportColumns: MaterialTableColumnProps[] = [
  { header: "Invoice ID", accessorKey: "invoice_number", visible: true, type: "string" },
  { header: "Supplier Invoice ID", accessorKey: "supplier_invoice_id", visible: true, type: "string" },
  { header: "Supplier Name", accessorKey: "supplier_name", visible: true, type: "string" },
  { header: "Invoice Date", accessorKey: "invoice_date", visible: true, type: "date" },
  { header: "Supplier Invoice Date", accessorKey: "supplier_invoice_date", visible: true, type: "date" },
  { header: "Due Date", accessorKey: "due_date", visible: true, type: "date" },
  { header: "Status", accessorKey: "approval_status", visible: true, type: "status" },
  { header: "Payment Status", accessorKey: "payment_status", visible: true, type: "status" },
  { header: "Total Value", accessorKey: "total_value", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "tax_amount", visible: true, type: "toFixed" },
  { header: "Currency", accessorKey: "currency", visible: true, type: "string" },
  { header: "Department", accessorKey: "department", visible: true, type: "string" },
  { header: "Amount Paid", accessorKey: "amount_paid", visible: true, type: "toFixed" },
  { header: "Amount Due", accessorKey: "amount_due", visible: true, type: "toFixed" },
  { header: "Location", accessorKey: "location_name", visible: true, type: "string" },
  { header: "GRN No", accessorKey: "grn_numbers", visible: true, type: "string" },
];

export const purchaseInvoiceDetailReportColumns: MaterialTableColumnProps[] = [
  { header: "Invoice ID", accessorKey: "invoice_id", visible: true, type: "string" },
  { header: "Invoice Date", accessorKey: "invoice_date", visible: true, type: "date" },
  { header: "Supplier", accessorKey: "supplier", visible: true, type: "string" },
  { header: "Product ID", accessorKey: "product_id", visible: true, type: "string" },
  { header: "Product / Account", accessorKey: "product_or_account", visible: true, type: "string" },
  { header: "Type", accessorKey: "line_type", visible: true, type: "string" },
  { header: "SKU", accessorKey: "sku", visible: true, type: "string" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
  { header: "Payment Status", accessorKey: "payment_status", visible: true, type: "status" },
  { header: "Quantity", accessorKey: "quantity", visible: true, type: "string" },
  { header: "Unit Price", accessorKey: "unit_price", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "tax", visible: true, type: "toFixed" },
  { header: "Tax Template", accessorKey: "tax_template", visible: true, type: "string" },
  { header: "Discount", accessorKey: "discount", visible: true, type: "toFixed" },
  { header: "Total Line Amount", accessorKey: "total_line_amount", visible: true, type: "toFixed" },
  { header: "Actual Price", accessorKey: "actual_price", visible: true, type: "toFixed" },
  { header: "Zero Rate Amount", accessorKey: "zero_rate", visible: true, type: "toFixed" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "GRN No", accessorKey: "grn_numbers", visible: true, type: "string" },
];

export const salesCommissionIncentiveReportColumns: MaterialTableColumnProps[] = [
  { header: "SO ID", accessorKey: "so_id", visible: true, type: "string" },
  { header: "Salesperson", accessorKey: "salesperson_name", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
  { header: "Order", accessorKey: "order_id", visible: true, type: "string" },
  { header: "Order Date", accessorKey: "order_date", visible: true, type: "date" },
  { header: "Total Sales", accessorKey: "total_sales", visible: true, type: "toFixed" },
  { header: "Total Returns", accessorKey: "total_returns", visible: true, type: "toFixed" },
  { header: "Commission Rate", accessorKey: "commission_rate", visible: true, type: "toFixed" },
  { header: "Incentive Earned", accessorKey: "incentive_earned", visible: true, type: "toFixed" },
];

export const salesChannelAnalysisReportColumns: MaterialTableColumnProps[] = [
  { header: "Sales Channel", accessorKey: "sales_channel", visible: true, type: "string" },
  { header: "Region", accessorKey: "region", visible: true, type: "string" },
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
  { header: "Order Count", accessorKey: "order_count", visible: true, type: "string" },
  { header: "Total Sales Value", accessorKey: "total_sales_value", visible: true, type: "toFixed" },
  { header: "Avg Order Value", accessorKey: "avg_order_value", visible: true, type: "toFixed" },
  { header: "Returns", accessorKey: "returns", visible: true, type: "toFixed" },
  { header: "Customer Count", accessorKey: "customer_count", visible: true, type: "string" },
];

export const salesDiscountPromotionAnalysisReportColumns: MaterialTableColumnProps[] = [
  { header: "Order ID", accessorKey: "order_id", visible: true, type: "string" },
  { header: "Product ID", accessorKey: "product_id", visible: true, type: "string" },
  { header: "Product Name", accessorKey: "product_name", visible: true, type: "string" },
  { header: "Discount Applied", accessorKey: "total_discount_applied", visible: true, type: "string" },
  { header: "Promotion Code", accessorKey: "promotion_code", visible: true, type: "string" },
  { header: "Sales Value", accessorKey: "sales_value", visible: true, type: "toFixed" },
  { header: "Qty Sold", accessorKey: "quantity_sold", visible: true, type: "string" },
  { header: "Customer ID", accessorKey: "customer_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
];

export const salesBySalespersonPerformanceReportColumns: MaterialTableColumnProps[] = [
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Total Sales Value", accessorKey: "total_sales_value", visible: true, type: "number" },
  { header: "Order Count", accessorKey: "order_count", visible: true, type: "number" },
  { header: "Avg Order Value", accessorKey: "average_order_value", visible: true, type: "number" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
];

export const pendingQuotesApprovalsReportColumns: MaterialTableColumnProps[] = [
  { header: "Quote", accessorKey: "quote_id", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "Quote Date", accessorKey: "quote_date", visible: true, type: "date" },
  { header: "Validity Date", accessorKey: "validity_date", visible: true, type: "date" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Total Quote Value", accessorKey: "total_quote_value", visible: true, type: "toFixed" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
  { header: "Days Since Quote", accessorKey: "days_since_quote", visible: true, type: "string" },
];

export const orderFulfillmentDeliveryReportColumns: MaterialTableColumnProps[] = [
  { header: "Order", accessorKey: "order_id", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "Order Date", accessorKey: "order_date", visible: true, type: "date" },
  { header: "Delivery Date", accessorKey: "delivery_date", visible: true, type: "date" },
  { header: "Expected Delivery Date", accessorKey: "expected_delivery_date", visible: true, type: "date" },
  { header: "Delivery Status", accessorKey: "delivery_status", visible: true, type: "status" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Delay Reason", accessorKey: "delay_reason", visible: true, type: "string" },
];

export const customerChurnRetentionReportColumns: MaterialTableColumnProps[] = [
  { header: "Customer ID", accessorKey: "customer_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer", visible: true, type: "string" },
  { header: "Last Order Date", accessorKey: "last_order_date", visible: true, type: "string" },
  { header: "Total Orders", accessorKey: "total_orders", visible: true, type: "number" },
  { header: "Total Sales Value", accessorKey: "total_sales_value", visible: true, type: "number" },
  { header: "Months Since Last Order", accessorKey: "months_since_last_order", visible: true, type: "number" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Customer Segment", accessorKey: "customer_segment", visible: true, type: "string" },
];

export const salesReturnCreditNoteReportColumns: MaterialTableColumnProps[] = [
  { header: "Return ID", accessorKey: "return_id_placeholder", visible: true, type: "string" },
  { header: "Sales Order", accessorKey: "sales_order_no", visible: true, type: "string" },
  { header: "Sales Invoice", accessorKey: "sales_invoice_no", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "Product", accessorKey: "product", visible: true, type: "string" },
  { header: "Return Qty", accessorKey: "return_quantity", visible: true, type: "number" },
  { header: "Return Date", accessorKey: "return_date", visible: true, type: "date" },
  { header: "Credit Amount", accessorKey: "credit_amount", visible: true, type: "number" },
  { header: "Reason", accessorKey: "reason", visible: true, type: "string" },
  { header: "Salesperson", accessorKey: "salesperson", visible: true, type: "string" },
];

export const regionalBranchSalesPerformanceReportColumns: MaterialTableColumnProps[] = [
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Order Count", accessorKey: "total_orders", visible: true, type: "string" },
  { header: "Total Sales Value", accessorKey: "total_sales_value", visible: true, type: "toFixed" },
  { header: "Avg Order Value", accessorKey: "avg_order_value", visible: true, type: "toFixed" },
  { header: "New Customers", accessorKey: "new_customers", visible: true, type: "string" },
  { header: "Existing Customers", accessorKey: "existing_customers", visible: true, type: "string" },
  { header: "Top Product", accessorKey: "product_name", visible: true, type: "string" },
];

export const regionalBranchSalesReportColumns: MaterialTableColumnProps[] = [
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
  { header: "Region", accessorKey: "region", visible: true, type: "string" },
  { header: "Order Count", accessorKey: "order_count", visible: true, type: "number" },
  { header: "Total Sales Value", accessorKey: "total_sales_value", visible: true, type: "toFixed" },
  { header: "Avg Order Value", accessorKey: "avg_order_value", visible: true, type: "toFixed" },
  { header: "New Customers", accessorKey: "new_customers", visible: true, type: "number" },
  { header: "Existing Customers", accessorKey: "existing_customers", visible: true, type: "number" },
  { header: "Top Product", accessorKey: "top_product", visible: true, type: "string" },
];

export const customerReturnsColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.customerReturn.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
    size: 100,
  },
  {
    header: "crm.customerReturn.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "crm.customerReturn.table.customer_header",
    accessorKey: "customer_data.name",
    visible: true,
    type: "string",
    enableSorting: false,
  },
  {
    header: "crm.customerReturn.table.salesperson_header",
    accessorKey: "salesperson_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.customerReturn.table.salesorder_header",
    accessorKey: "sales_order_data.name",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "crm.customerReturn.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.customerReturn.table.rma_status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const shippingRuleColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.shippmentRules.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "number",
    size: 100,
  },
  {
    header: "crm.shippmentRules.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.shippmentRules.table.company_header",
    accessorKey: "company_data",
    visible: true,
    type: "custom",
    enableSorting: false,
  },
  {
    header: "crm.shippmentRules.table.shipping_cost_header",
    accessorKey: "shipping_cost",
    visible: true,
    type: "currency",
  },
  {
    header: "crm.shippmentRules.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const promotionColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.promotions.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "crm.promotions.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.promotions.table.type_header",
    accessorKey: "type",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "crm.promotions.table.items_header",
    accessorKey: "item",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "crm.promotions.table.company_header",
    accessorKey: "company_id",
    visible: true,
    valueGet: "name",
    type: "custom",
    enableSorting: false
  },
  {
    header: "crm.promotions.table.end_date_header",
    accessorKey: "end_date",
    visible: true,
    type: "date",
  },
  {
    header: "crm.promotions.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const customerSegmentColumns: MaterialTableColumnProps[] = [
  {
    header: "crm.customerSegment.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "crm.customerSegment.table.segmentName_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "crm.customerSegment.table.segmentDuration_header",
    accessorKey: "segment_duration",
    visible: true,
    type: "custom",
    enableSorting: false
  },
  {
    header: "crm.customerSegment.table.purchaseAmount_header",
    accessorKey: "purchase_amount",
    visible: true,
    type: "amount",
  },
  {
    header: "crm.customerSegment.table.purchaseCount_header",
    accessorKey: "purchase_count",
    visible: true,
    type: "number",
  },
  {
    header: "crm.customerSegment.table.validityStartDate_header",
    accessorKey: "segment_start_date",
    visible: true,
    type: "date",
  },
  {
    header: "crm.customerSegment.table.validityEndDate_header",
    accessorKey: "segment_end_date",
    visible: true,
    type: "date",
  },
  {
    header: "crm.customerSegment.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
    enableSorting: false
  },
  {
    header: "crm.customerSegment.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

export const purchaseRequestColumns: MaterialTableColumnProps[] = [
  {
    header: "procurement.request.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
    headerStyle: { width: 'auto' },
    cellStyle: { width: 'auto' },
  },
  {
    header: "procurement.request.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.request.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.request.table.representative_label",
    accessorKey: "purchase_representative_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.request.table.vendor_label",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.request.table.total_amount_label",
    accessorKey: "total_amount",
    visible: true,
    type: "currency",
  },
  {
    header: "procurement.request.table.status_label",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];

export const purchaseAgreementColumns: MaterialTableColumnProps[] = [
  {
    header: "purchase.agreement.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "purchase.agreement.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "purchase.agreement.table.name_header",
    accessorKey: "name",
    visible: true,
    type: "string",
  },
  {
    header: "purchase.agreement.table.purchase_representative_header",
    accessorKey: "purchase_representative_data.name",
    visible: true,
    size: 200,
    type: "custom",
  },
  {
    header: "purchase.agreement.table.vendor_header",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "purchase.agreement.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "purchase.agreement.table.valid_header",
    accessorKey: "valid_up_to",
    visible: true,
    type: "date",
  },
  {
    header: "purchase.agreement.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];

export const purchaseRfqColumns: MaterialTableColumnProps[] = [
  {
    header: "procurement.requestForQuote.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
    size: 80,
  },
  {
    header: "procurement.requestForQuote.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.requestForQuote.table.referenceNo_header",
    accessorKey: "reference_number",
    visible: true,
    type: "string",
  },

  {
    header: "procurement.requestForQuote.table.vendor_header",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "custom",
    size: 200,
  },
  {
    header: "procurement.requestForQuote.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];

export const purchaseOrderColumns: MaterialTableColumnProps[] = [
  {
    header: "procurement.purchaseOrder.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.purchaseOrder.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.purchaseOrder.table.vendor_header",
    accessorKey: "supplier_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.purchaseOrder.table.purchaseRepresentative_header",
    accessorKey: "purchase_representative_data.name",
    visible: true,
    size: 200,
    type: "custom",
  },
  {
    header: "procurement.purchaseOrder.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.purchaseOrder.table.expectedReceipt_header",
    accessorKey: "expected_receipt_date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.purchaseOrder.table.totalValue_header",
    accessorKey: "total_amount",
    visible: true,
    type: "currency",
  },
  {
    header: "procurement.purchaseOrder.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.purchaseOrder.table.billingStatus_header",
    accessorKey: "billing_status",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.purchaseOrder.table.receivingStatus_header",
    accessorKey: "receiving_status",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.purchaseOrder.table.referenceNo_header",
    accessorKey: "reference_number",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.purchaseOrder.table.confirmationDate_header",
    accessorKey: "confirmation_date",
    visible: true,
    type: "date",
  },
];

export const purchaseVraColumns: MaterialTableColumnProps[] = [
  {
    header: "procurement.vendorReturns.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.vendorReturns.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.vendorReturns.table.vendor_header",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.vendorReturns.table.purchaseRepresentative_header",
    accessorKey: "purchase_representative_data.name",
    visible: true,
    size: 200,
    type: "custom",
  },
  {
    header: "procurement.vendorReturns.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.vendorReturns.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.vendorReturns.table.deliveryStatus_header",
    accessorKey: "delivery_status",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.vendorReturns.table.refundStatus_header",
    accessorKey: "refund_status",
    visible: true,
    type: "custom",
  },
];

export const purchaseDeliveryOrderColumns: MaterialTableColumnProps[] = [
  {
    header: "procurement.deliveryOrder.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
    size: 80,
  },
  {
    header: "procurement.deliveryOrder.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.deliveryOrder.table.returnAuthorization_header",
    accessorKey: "vendor_return_id",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.deliveryOrder.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.deliveryOrder.table.vendor_header",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "custom",
  },
  {
    header: "procurement.deliveryOrder.table.agreement_header",
    accessorKey: "agreement_data.name",
    visible: true,
    size: 200,
    type: "string",
  },
  {
    header: "procurement.deliveryOrder.table.company_header",
    accessorKey: "company_data.name",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.deliveryOrder.table.location_header",
    accessorKey: "location_data.name",
    visible: true,
    type: "string",
  },
];

export const purchaseLandedCostColumns: MaterialTableColumnProps[] = [
  {
    header: "procurement.landedCost.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "procurement.landedCost.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.landedCost.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "custom",
  },
];

// Rental Module
export const rentalTermsAndConditionsColumns: MaterialTableColumnProps[] = [
  {
    header: 'rental.settings.termsAndConditions.table.id',
    accessorKey: "series_number",
    visible: true,
    type: 'string',
    size: 80
  },
  {
    header: 'rental.settings.termsAndConditions.table.name',
    accessorKey: 'name',
    visible: true,
    type: 'string',
    size: 350
  },
  {
    header: 'rental.settings.termsAndConditions.table.status',
    accessorKey: 'is_active',
    visible: true,
    type: 'boolean',
    typeBooleanLabels: { 0: 'Inactive', 1: 'Active', false: 'Inactive', true: 'Active' }
  },
];

// CRM Module
export const crmTermsAndConditionsColumns: MaterialTableColumnProps[] = [
  {
    header: 'crm.settings.termsAndConditions.table.id',
    accessorKey: "series_number",
    visible: true,
    type: 'string',
    size: 80
  },
  {
    header: 'crm.settings.termsAndConditions.table.name',
    accessorKey: 'name',
    visible: true,
    type: 'string',
    size: 350
  },
  {
    header: 'crm.settings.termsAndConditions.table.status',
    accessorKey: 'is_active',
    visible: true,
    type: 'boolean',
    typeBooleanLabels: { 0: 'Inactive', 1: 'Active', false: 'Inactive', true: 'Active' }
  },
];
export const purchaseTermsAndConditionsColumns: MaterialTableColumnProps[] = [
  {
    header: 'procurement.termsAndConditions.table.id',
    accessorKey: "series_number",
    visible: true,
    type: 'string',
    size: 80
  },
  {
    header: 'procurement.termsAndConditions.table.name',
    accessorKey: 'name',
    visible: true,
    type: 'string',
    size: 350
  },
  {
    header: 'procurement.termsAndConditions.table.status',
    accessorKey: 'is_active',
    visible: true,
    type: 'boolean',
    typeBooleanLabels: { 0: 'Inactive', 1: 'Active', false: 'Inactive', true: 'Active' }
  },
];
export const rentalConfigurationColumns: MaterialTableColumnProps[] = [];
export const rentalBillingCycleColumns: MaterialTableColumnProps[] = [
  { header: "rental.settings.billingCycle.table.id", accessorKey: "series_number", visible: true, type: "string" },
  { header: "rental.settings.billingCycle.table.name", accessorKey: "name", visible: true, type: "string" },
  { header: "rental.settings.billingCycle.table.duration", accessorKey: "duration", visible: true, type: "string" },
  { header: "rental.settings.billingCycle.table.company", accessorKey: "company_data.name", visible: true, type: "string" },
];

export const rentalOpportunityColumns: MaterialTableColumnProps[] =
  [
    {
      header: "rental.opportunity.table.id_header",
      accessorKey: "party.series_number",
      visible: true,
      type: "string",
    },
    {
      header: "rental.opportunity.table.customer_header",
      accessorKey: "party.name",
      visible: true,
      type: "string",
      enableSorting: false
    },
    {
      header: "rental.opportunity.table.company_header",
      accessorKey: "companies_data",
      visible: true,
      type: "custom",
      enableSorting: false
    },
    {
      header: "rental.opportunity.table.expected_revenue_header",
      accessorKey: "expected_revenue",
      visible: true,
      type: "string",
    },
    {
      header: "rental.opportunity.table.stage_header",
      accessorKey: "stages",
      visible: true,
      type: "custom",
    },
    {
      header: "rental.opportunity.table.closing_date_header",
      accessorKey: "expected_closing_date",
      visible: true,
      type: "custom",
    },
    {
      header: "rental.opportunity.table.contact_name_header",
      accessorKey: "party_contact_data",
      visible: true,
      type: "custom",
      enableSorting: false
    },
    {
      header: "rental.opportunity.table.salesperson_header",
      accessorKey: "party.sales_person",
      visible: true,
      type: "string",
      enableSorting: false
    },
  ];
export const rentalLeadColumns: MaterialTableColumnProps[] = [
  {
    header: 'rental.leads.table.id_header',
    accessorKey: "series_number",
    visible: true,
    type: 'string'
  },
  {
    header: 'rental.leads.table.name_header',
    accessorKey: 'name',
    visible: true,
    type: 'string'
  },
  {
    header: 'rental.leads.table.company_header',
    accessorKey: 'companies_data',
    visible: true,
    type: 'array',
    typeArrayAccessorKey: 'name',
    custom_class: 'leads--StatusChip--company'
  },
  {
    header: 'rental.leads.table.lead_status_header',
    accessorKey: 'sales_lead_status',
    visible: true,
    type: 'status'
  },
  {
    header: 'rental.leads.table.owner_header',
    accessorKey: 'sales_lead_owner_salesperson_data.name',
    visible: true,
    type: 'owner'
  },
  {
    header: 'rental.leads.table.source_header',
    accessorKey: 'sales_source',
    visible: true,
    type: 'string'
  },

];
export const rentalQuotationColumns: MaterialTableColumnProps[] = [
  { header: "rental.orders.quotation.table.id", accessorKey: "series_number", visible: true, type: "custom" },
  { header: "rental.orders.quotation.table.date", accessorKey: "date", visible: true, type: "date" },
  { header: "rental.orders.quotation.table.customer", accessorKey: "customer_data.name", visible: true, type: "string" },
  { header: "rental.orders.quotation.table.status", accessorKey: "status", visible: true, type: "custom" },
  { header: "rental.orders.quotation.table.salesPerson", accessorKey: "salesperson_data.name", visible: true, type: "string" },
];


export const rentalAgreementsColumns: MaterialTableColumnProps[] = [
  {
    header: "rental.agreement.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
  },
  {
    header: "rental.agreement.table.date_header",
    accessorKey: 'date',
    visible: true,
    type: "date",
  },
  {
    header: "rental.agreement.table.name_header",
    accessorKey: 'name',
    visible: true,
    type: "string",
  },
  {
    header: "rental.agreement.table.purchase_representative_header",
    accessorKey: 'purchase_representative_data.name',
    visible: true,
    size: 200,
    type: "custom_link",
  },
  {
    header: "rental.agreement.table.vendor_header",
    accessorKey: 'vendor_data.name',
    visible: true,
    type: "custom_link",
  },
  {
    header: "rental.agreement.table.company_header",
    accessorKey: 'company_data.name',
    visible: true,
    type: "string",
  },
  {
    header: "rental.agreement.table.valid_header",
    accessorKey: 'valid_up_to',
    visible: true,
    type: "date",
  },
  {
    header: "rental.agreement.table.status_header",
    accessorKey: 'status',
    visible: true,
    type: "status",
  },
];
export const rentalCrossHireRequestColumns: MaterialTableColumnProps[] = [
  { header: "rental.crossHire.request.table.id", accessorKey: "series_number", visible: true, type: "custom" },
  { header: "rental.crossHire.request.table.date", accessorKey: "date", visible: true, type: "date" },
  { header: "rental.crossHire.request.table.rentalOrderId", accessorKey: "rental_order_data.series_number", visible: true, type: "string" },
  { header: "rental.crossHire.request.table.status", accessorKey: "status", visible: true, type: "status" },
];

export const rentalCrossHireRfqColumns: MaterialTableColumnProps[] = [
  {
    header: "procurement.requestForQuote.table.id_header",
    accessorKey: "series_number",
    visible: true,
    type: "string",
    size: 80,
  },
  {
    header: "procurement.requestForQuote.table.date_header",
    accessorKey: "date",
    visible: true,
    type: "date",
  },
  {
    header: "procurement.requestForQuote.table.referenceNo_header",
    accessorKey: "reference_number",
    visible: true,
    type: "string",
  },

  {
    header: "procurement.requestForQuote.table.vendor_header",
    accessorKey: "vendor_data.name",
    visible: true,
    type: "custom",
    size: 200,
  },
  {
    header: "procurement.requestForQuote.table.status_header",
    accessorKey: "status",
    visible: true,
    type: "status",
  },
];
export const rentalOrderColumns: MaterialTableColumnProps[] = [
  { header: "rental.orders.rentalOrder.table.id", accessorKey: "series_number", visible: true, type: "custom" },
  { header: "rental.orders.rentalOrder.table.date", accessorKey: "date", visible: true, type: "date" },
  { header: "rental.orders.rentalOrder.table.customer", accessorKey: "customer_data.name", visible: true, type: "string" },
  { header: "rental.orders.rentalOrder.table.status", accessorKey: "status", visible: true, type: "status" },
  { header: "rental.orders.rentalOrder.table.invoiceStatus", accessorKey: "invoice_status", visible: true, type: "status" },
  { header: "rental.orders.rentalOrder.table.deliveryStatus", accessorKey: "delivery_status", visible: true, type: "status" },
  { header: "rental.orders.rentalOrder.table.salesPerson", accessorKey: "salesperson_data.name", visible: true, type: "string" },
  { header: "rental.orders.rentalOrder.table.totalAmount", accessorKey: "total_amount", visible: true, type: "string" },
  { header: "rental.orders.rentalOrder.table.paymentTerm", accessorKey: "payment_term_data.name", visible: true, type: "string" },
  { header: "rental.orders.rentalOrder.table.poNumber", accessorKey: "po_number", visible: true, type: "string" },
];
export const rentalCrossHireOrderColumns: MaterialTableColumnProps[] = [
  { header: "rental.crossHire.orders.table.hire_order_number", accessorKey: "series_number", visible: true, type: "string" },
  { header: "rental.crossHire.orders.table.date", accessorKey: "date", visible: true, type: "date" },
  { header: "rental.crossHire.orders.table.reference_number", accessorKey: "reference_number", visible: true, type: "string" },
  { header: "rental.crossHire.orders.table.confirmation_date", accessorKey: "confirmation_date", visible: true, type: "date" },
  { header: "rental.crossHire.orders.table.vendor", accessorKey: "supplier_data.name", visible: true, type: "string" },
  { header: "rental.crossHire.orders.table.purchaseRepresentative_header", accessorKey: "purchase_representative_data.name", visible: true, type: "string" },
  { header: "rental.crossHire.orders.table.company_header", accessorKey: "company_data.name", visible: true, type: "string" },
  { header: "rental.crossHire.orders.table.expectedReceipt_header", accessorKey: "expected_receipt_date", visible: true, type: "date" },
  { header: "rental.crossHire.orders.table.totalValue_header", accessorKey: "total_amount", visible: true, type: "currency" },
  { header: "rental.crossHire.orders.table.status_header", accessorKey: "status", visible: true, type: "status" },
  { header: "rental.crossHire.orders.table.billingStatus_header", accessorKey: "billing_status", visible: true, type: "status" },
  { header: "rental.crossHire.orders.table.receivingStatus_header", accessorKey: "receiving_status", visible: true, type: "status" },
];

export const emailColumns: MaterialTableColumnProps[] = [
  // {
  //   header: 'ID',
  //   accessorKey: '_id',
  //   visible: true,
  //   type: 'string',
  //   size: 100
  // },
  // {
  //   header: 'Date',
  //   accessorKey: 'created_at',
  //   visible: true,
  //   type: 'date',
  //   size: 80
  // },
  {
    header: 'Subject',
    accessorKey: 'subject',
    visible: true,
    type: 'string',
    size: 500
  },
]

export const rolesColumns = [
  {
    header: "Role",
    type: "string",
    accessorKey: "role",
    visible: true,
  },
  {
    type: "boolean",
    header: "Status",
    accessorKey: "status",
    visible: true,
  },
  {
    header: "Role Type",
    type: "string",
    accessorKey: "roleType",
    visible: true,
  },
  {
    header: "Date Created",
    type: "date",
    accessorKey: "date",
    visible: true,
  },
];


export const approvalWorkFlowColumns = [
  {
    accessorKey: "workflow_title",
    header: "Workflow Title",
  },
  {
    accessorKey: "request_category",
    header: "Request Category",
  },
  {
    accessorKey: "request_type",
    header: "Request Type",
  },
  {
    accessorKey: "is_active",
    header: "Status",
  },
];

// HRMS Module
export const hrmsDocumentMasterColumns: MaterialTableColumnProps[] = [
  {
    header: 'hrms.document_master.columns.id',
    accessorKey: "series_number",
    visible: true,
    type: 'string'
  },
  {
    header: 'hrms.document_master.columns.document_type',
    accessorKey: 'document_type_name',
    visible: true,
    type: 'string'
  },
  {
    header: 'hrms.document_master.columns.total_documents',
    accessorKey: 'total_documents',
    visible: true,
    type: 'string'
  },
  {
    header: 'hrms.document_master.columns.status',
    accessorKey: 'status',
    visible: true,
    type: "custom",
    typeBooleanLabels: { 0: 'Inactive', 1: 'Active', false: 'Inactive', true: 'Active' }
  }
];

export const hrmsCompanyCalendarColumns: MaterialTableColumnProps[] = [
  {
    header: 'ID',
    accessorKey: "series_number",
    visible: true,
    type: 'string'
  },
  {
    header: 'Name',
    accessorKey: 'calendar_name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Company Name',
    accessorKey: 'company_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Location',
    accessorKey: 'location_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Status',
    accessorKey: 'status',
    visible: false,
    type: 'boolean',
    typeBooleanLabels: { 0: 'Inactive', 1: 'Active', false: 'Inactive', true: 'Active' }
  },
]

export const hrmsLeavePolicyMasterColumns: MaterialTableColumnProps[] = [
  {
    header: 'ID',
    accessorKey: 'series_number',
    visible: true,
    type: 'string'
  },
  {
    header: 'Policy Name',
    accessorKey: 'leave_type_title',
    visible: true,
    type: 'string'
  },
  {
    header: 'Category',
    accessorKey: 'leave_category_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Effective From',
    accessorKey: 'effective_from',
    visible: true,
    type: 'date'
  },
  {
    header: 'Location',
    accessorKey: 'location_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Department',
    accessorKey: 'department_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Status',
    accessorKey: 'is_active',
    visible: true,
    type: 'custom',
    typeBooleanLabels: { 0: 'Inactive', 1: 'Active', false: 'Inactive', true: 'Active' }
  },
];

export const hrmsSalaryStructureMasterColumns: MaterialTableColumnProps[] = [
  {
    header: 'ID',
    accessorKey: "series_number",
    visible: true,
    type: 'string'
  },
  {
    header: 'Structure Name',
    accessorKey: 'structure_name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Grade',
    accessorKey: 'grade_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Location',
    accessorKey: 'location_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Company',
    accessorKey: 'company_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Department',
    accessorKey: 'department_data.name',
    visible: true,
    type: 'string'
  }
];

export const hrmsEmployeeManagementColumns: MaterialTableColumnProps[] = [
  {
    header: 'hrms.employee_management.columns.id',
    accessorKey: "series_number",
    visible: true,
    type: 'string',
  },
  {
    header: 'hrms.employee_management.columns.employee_name',
    accessorKey: 'name',
    visible: true,
    type: 'string'
  },
  {
    header: 'hrms.employee_management.columns.company',
    accessorKey: 'company_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'hrms.employee_management.columns.department',
    accessorKey: 'department_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'hrms.employee_management.columns.designation',
    accessorKey: 'designation_data.name',
    visible: true,
    type: 'string'
  },
  {
    header: 'Status',
    accessorKey: 'status',
    visible: true,
    type: 'status',
  },
];

// Rental Reports Columns
export const rentalRevenueReportColumns: MaterialTableColumnProps[] = [
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Asset Name", accessorKey: "asset_name", visible: true, type: "string" },
  { header: "Start Date", accessorKey: "start_date", visible: true, type: "date" },
  { header: "End Date", accessorKey: "end_date", visible: true, type: "date" },
  { header: "Rental Rate", accessorKey: "rental_rate", visible: true, type: "number" },
  { header: "Total Amount", accessorKey: "total_amount", visible: true, type: "number" },
  { header: "Payment Status", accessorKey: "payment_status", visible: true, type: "status" },
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
];

export const rentalAgreementReportColumns: MaterialTableColumnProps[] = [
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Asset Name", accessorKey: "asset_name", visible: true, type: "string" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
  { header: "Start Date", accessorKey: "start_date", visible: true, type: "date" },
  { header: "End Date", accessorKey: "end_date", visible: true, type: "date" },
  { header: "Rental Value", accessorKey: "rental_value", visible: true, type: "number" },
  { header: "Payment Terms", accessorKey: "payment_terms", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Rental Type", accessorKey: "rental_type", visible: true, type: "string" },
];

export const rentalAgreementDetailReportColumns: MaterialTableColumnProps[] = [
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "SKU", accessorKey: "sku", visible: true, type: "string" },
  { header: "Asset ID/Name", accessorKey: "asset_id_name", visible: true, type: "string" },
  { header: "Requested Qty", accessorKey: "requested_quantity", visible: true, type: "number" },
  { header: "Delivered Qty", accessorKey: "delivered_quantity", visible: true, type: "number" },
  { header: "Pending Delivery Qty", accessorKey: "pending_delivery_quantity", visible: true, type: "number" },
  { header: "Returned Qty", accessorKey: "returned_quantity", visible: true, type: "number" },
  { header: "Pending Return Qty", accessorKey: "pending_return_quantity", visible: true, type: "number" },
  { header: "Scrap Qty", accessorKey: "scrap_quantity", visible: true, type: "number" },
  { header: "Missing Qty", accessorKey: "missing_quantity", visible: true, type: "number" },
  { header: "Replaced Qty", accessorKey: "replaced_quantity", visible: true, type: "number" },
  { header: "Rental Start", accessorKey: "rental_start", visible: true, type: "date" },
  { header: "Rental End", accessorKey: "rental_end", visible: true, type: "date" },
  { header: "Rent Duration (Days)", accessorKey: "rent_duration", visible: true, type: "number" },
  { header: "Rate", accessorKey: "rate", visible: true, type: "toFixed" },
  { header: "Tax", accessorKey: "tax_amount", visible: true, type: "toFixed" },
  { header: "Payment Terms", accessorKey: "payment_terms", visible: true, type: "string" },
  { header: "Discounts", accessorKey: "discounts", visible: true, type: "toFixed" },
  { header: "Deposit", accessorKey: "deposit", visible: true, type: "toFixed" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Delivery NO", accessorKey: "delivery_order_numbers", visible: true, type: "string" },
];

export const rentalAssetReturnReportColumns: MaterialTableColumnProps[] = [
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Asset ID/Name", accessorKey: "asset_id_name", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "Scheduled Return Date", accessorKey: "scheduled_return_date", visible: true, type: "date" },
  { header: "Actual Return Date", accessorKey: "actual_return_date", visible: true, type: "date" },
  { header: "Condition", accessorKey: "condition", visible: true, type: "string" },
  { header: "Late Fees", accessorKey: "late_fees", visible: true, type: "toFixed" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
];

export const rentalCancellationsAmendmentsReportColumns: MaterialTableColumnProps[] = [
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Customer", accessorKey: "customer", visible: true, type: "string" },
  { header: "Asset ID/Name", accessorKey: "asset_id_name", visible: true, type: "string" },
  { header: "Original Terms", accessorKey: "original_terms", visible: true, type: "string" },
  { header: "Modified Terms", accessorKey: "modified_terms", visible: true, type: "string" },
  { header: "Cancellation Reason", accessorKey: "cancellation_reason", visible: true, type: "string" },
  { header: "Date", accessorKey: "date", visible: true, type: "date" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
];

export const rentalPaymentAgingReportColumns: MaterialTableColumnProps[] = [
  { header: "Customer ID", accessorKey: "customer_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Invoice ID", accessorKey: "invoice_id", visible: true, type: "string" },
  { header: "Due Date", accessorKey: "due_date", visible: true, type: "date" },
  { header: "Invoice Amount", accessorKey: "invoice_amount", visible: true, type: "toFixed" },
  { header: "Paid Amount", accessorKey: "paid_amount", visible: true, type: "toFixed" },
  { header: "Outstanding Amount", accessorKey: "outstanding_amount", visible: true, type: "toFixed" },
  { header: "Aging Bucket", accessorKey: "aging_bucket", visible: true, type: "string" },
];

export const activeRentalsReportColumns: MaterialTableColumnProps[] = [
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Asset Name", accessorKey: "asset_name", visible: true, type: "string" },
  { header: "Start Date", accessorKey: "start_date", visible: true, type: "date" },
  { header: "End Date", accessorKey: "end_date", visible: true, type: "date" },
  { header: "Rental Duration", accessorKey: "rental_duration", visible: true, type: "number" },
  { header: "Rental Value", accessorKey: "rental_value", visible: true, type: "number" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Status", accessorKey: "status", visible: true, type: "status" },
  { header: "Assigned Staff", accessorKey: "assigned_staff", visible: true, type: "string" },
];

export const upcomingExpiryReportColumns: MaterialTableColumnProps[] = [
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Start Date", accessorKey: "start_date", visible: true, type: "date" },
  { header: "End Date", accessorKey: "end_date", visible: true, type: "date" },
  { header: "Days To Expiry", accessorKey: "days_to_expiry", visible: true, type: "number" },
  { header: "Rental Value", accessorKey: "rental_value", visible: true, type: "number" },
  { header: "Renewal Status", accessorKey: "renewal_status", visible: true, type: "string" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
];

export const assetAvailabilityReportColumns: MaterialTableColumnProps[] = [
  { header: "Asset ID", accessorKey: "asset_id", visible: true, type: "string" },
  { header: "Asset Name", accessorKey: "asset_name", visible: true, type: "string" },
  { header: "Current Status", accessorKey: "current_status", visible: true, type: "status" },
  { header: "Next Available Date", accessorKey: "next_available_date", visible: true, type: "date" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Asset Category", accessorKey: "asset_category", visible: true, type: "string" },
];

export const assetUtilizationReportColumns: MaterialTableColumnProps[] = [
  { header: "Asset Name", accessorKey: "asset_name", visible: true, type: "string" },
  { header: "Total Rental Days", accessorKey: "total_rental_days", visible: true, type: "number" },
  { header: "Idle Days", accessorKey: "idle_days", visible: true, type: "number" },
  { header: "Utilization Percentage", accessorKey: "utilization_percentage", visible: true, type: "number" },
  { header: "Rental Frequency", accessorKey: "rental_frequency", visible: true, type: "number" },
  { header: "Customer Count", accessorKey: "customer_count", visible: true, type: "number" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
];

export const assetCategoryPerformanceReportColumns: MaterialTableColumnProps[] = [
  { header: "Asset Category", accessorKey: "asset_category", visible: true, type: "string" },
  { header: "Total Rentals", accessorKey: "total_rentals", visible: true, type: "number" },
  { header: "Revenue", accessorKey: "revenue", visible: true, type: "toFixed" },
  { header: "Average Utilization", accessorKey: "average_utilization", visible: true, type: "toFixed" },
  { header: "Maintenance Costs", accessorKey: "maintenance_costs", visible: true, type: "toFixed" },
  { header: "Customer Count", accessorKey: "customer_count", visible: true, type: "number" },
  { header: "Period", accessorKey: "period", visible: true, type: "string" },
];

export const customerRentalReportColumns: MaterialTableColumnProps[] = [
  { header: "Customer ID", accessorKey: "customer_id", visible: true, type: "string" },
  { header: "Customer Name", accessorKey: "customer_name", visible: true, type: "string" },
  { header: "Agreement ID", accessorKey: "agreement_id", visible: true, type: "string" },
  { header: "Rental Period", accessorKey: "rental_period", visible: true, type: "number" },
  { header: "Rental Value", accessorKey: "rental_value", visible: true, type: "number" },
  { header: "Payment Status", accessorKey: "payment_status", visible: true, type: "status" },
  { header: "Location", accessorKey: "location", visible: true, type: "string" },
  { header: "Rental Type", accessorKey: "rental_type", visible: true, type: "string" },
];

export const hrmsLoanConfigurationColumns: MaterialTableColumnProps[] = [
  {
    accessorKey: "series_number",
    header: "hrms.loan-configuration.columns.id",
    type: "number",
    visible: true,
  },
  {
    accessorKey: "loan_name",
    header: "hrms.loan-configuration.columns.loan_name",
    type: "string",
    visible: true,
  },
  {
    accessorKey: "loan_category",
    header: "hrms.loan-configuration.columns.loan_type",
    type: "string",
    visible: true,
  },
  {
    accessorKey: "max_tenure_months",
    header: "hrms.loan-configuration.columns.tenure",
    type: "string",
    visible: true,
  },
  {
    accessorKey: "status",
    header: "common.status",
    type: "boolean",
    visible: true,
    typeBooleanLabels: {
      1: "Active",
      0: "Inactive",
      true: "Active",
      false: "Inactive",
    }
  },
];

export const masterJobCardColumns: MaterialTableColumnProps[] = [
  { header: "Series Number", accessorKey: "series_number", visible: true, type: "string" },
  { header: "Date", accessorKey: "date", visible: true, type: "date" },
  { header: "Category", accessorKey: "type", visible: true, type: "string" },
  { header: "Work Orders", accessorKey: "work_order_count", visible: true, type: "string" },
  { header: "Production Start", accessorKey: "production_start_date", visible: true, type: "date" },
  { header: "Production End", accessorKey: "production_end_date", visible: true, type: "date" },
  { header: "Status", accessorKey: "status", visible: true, type: "string" },
];

export const journalItemReportColumns: MaterialTableColumnProps[] = [
  { header: "Journal No",   accessorKey: "series_number",                     visible: true, type: "string" },
  { header: "Source Ref",   accessorKey: "ref_data.sales_order_series_number",visible: true, type: "string" },
  { header: "Date",          accessorKey: "posting_date",                      visible: true, type: "date"   },
  { header: "Account Number",accessorKey: "account_code",                      visible: true, type: "string" },
  { header: "Account Name",  accessorKey: "account_name",                     visible: true, type: "string" },
  { header: "Payee",         accessorKey: "ref_data.payee_name",               visible: true, type: "string" },
  { header: "Voucher Type",  accessorKey: "journal_name",                     visible: true, type: "string" },
  { header: "Dr/Cr",         accessorKey: "dr_cr",                             visible: true, type: "string" },
  { header: "Debit",         accessorKey: "debit_amount",                      visible: true, type: "string" },
  { header: "Credit",        accessorKey: "credit_amount",                     visible: true, type: "string" },
  { header: "Balance",       accessorKey: "balance",                           visible: false, type: "amount" },
  { header: "Document ID",   accessorKey: "ref_data.document_series_number",   visible: false, type: "string" },
  { header: "Narration",     accessorKey: "narration",                         visible: true, type: "string" },
];
